import React from 'react';
import axios from 'axios';
import anime from 'animejs';
import WheelPageSZJP from './WheelPageSZJP';
import OnlineGameMenu from './OnlineGameMenu';
import JackpotSVG from '../assets/JackpotSVG';
import MiniJackpotAmount from './jackpot/MiniJackpotAmount';
import options from './options_ORIG.json';
import betmap from './betmap.json';
import { FaVolumeMute, FaVolumeUp } from 'react-icons/fa';
import { API_URL } from './environment';
import casinoBackgroundMusic from './../images/roulette_casino_bg_mus.mp3';
import chipPlacementSound from './../images/roulette_chip_place.mp3';
import winCelebrationSound from './../images/roulette_casino_win.mp3';
// profit win sound
import congratsWinCelebrationSound from './../images/yahuuu_congrats.mp3';
import {
  clearPersistedPlayerSession as clearCachedPlayerSession,
  getLaunchTokenFromUrl as getOnlineLaunchTokenFromUrl,
  getPlayerSessionHeaders,
  getStoredPlayerSession as getCachedPlayerSession,
  isNetworkRequestError,
  isPlayerSessionExpired,
  isSessionAuthorizationError,
  persistPlayerSession as persistCachedPlayerSession,
} from './onlinePlayerSession';
import {
  ONLINE_AUTO_BET_SUBMIT_START,
  ONLINE_ROUND_SECONDS,
  ONLINE_SPIN_ENTRY_LOCK_SECONDS,
  ONLINE_SPIN_ENTRY_LOCK_START,
} from './onlineRouletteTiming';
import './OnlineWheelPageSZJP.css';

const PLAYER_SESSION_EXCHANGE_PATHS = ['/playersessions/exchange', '/api/provider/v1/betconstruct/launch', '/login'];
const PLAYER_SESSION_ME_PATHS = ['/playersessions/me', '/api/provider/v1/betconstruct/session/me'];
const PLAYER_BETS_PATHS = ['/createticket'];
const ONLINE_BET_SUCCESS_MESSAGE = 'Bet placed successfully.';
const ONLINE_PLAYER_HISTORY_KEY = 'sun_online_player_history';
const ONLINE_GAME_SESSION_STATE_KEY = 'sun_online_roulette_game_state';
const ONLINE_REPEAT_BETS_STORAGE_KEY = 'sun_online_roulette_repeat_bets';
const ONLINE_REPEAT_BETS_STORAGE_LIMIT = 10;
const ONLINE_PROGRESS_DURATION_SECONDS = Math.max(ONLINE_AUTO_BET_SUBMIT_START - 1, 1);
const ONLINE_BALANCE_INITIAL_AMOUNT = 10000;
const ONLINE_BALANCE_REFRESH_DELAY_MS = 12500;
const ONLINE_POST_ROUND_BALANCE_REFRESH_DELAY_MS = 5000;
const ONLINE_BALANCE_ANIMATION_MS = 900;
const ONLINE_WIN_CELEBRATION_MS = 3800;
const ONLINE_IDLE_WHEEL_TURN_MS = 8000;
const ONLINE_PRE_SPIN_DURATION_MS = 10000;
const ONLINE_BACKGROUND_MUSIC_VOLUME = 0.06;
const ONLINE_CHIP_PLACEMENT_VOLUME = 0.58;
const ONLINE_AUTH_REQUEST_TIMEOUT_MS = 8000;
const ONLINE_DESKTOP_SPLIT_LAYOUT_QUERY = '(min-width: 900px)';
const ONLINE_LARGE_DESKTOP_LAYOUT_QUERY = '(min-width: 1800px)';
const ONLINE_FORCE_WHEEL_VIEW_EVENT = 'onlineRoulette:forceWheelView';
const ONLINE_FORCE_WHEEL_VIEW_KEY = 'sun_online_roulette_force_wheel_view';
const MAX_TOTAL_BET_AMOUNT = 30000;
const MAX_INSIDE_BET_AMOUNT = 2000;
const MAX_OUTSIDE_BET_AMOUNT = 5000;
const OUTSIDE_BET_KEYS = new Set([
  'BLACK',
  'RED',
  'ODD',
  'EVEN',
  'HIGH',
  'LOW',
  'COLUMN1',
  'COLUMN2',
  'COLUMN3',
  'DOZEN1',
  'DOZEN2',
  'DOZEN3',
  'ZEROSPIEL',
  'ORPHELINS',
  'VOISINS',
  'REDSPLIT',
  'BLACKSPLIT',
  'TIERS',
  'SNAKE',
]);
const ONLINE_RACETRACK_TOP_NUMBERS = [3, 26, 0, 32];
const ONLINE_RACETRACK_LEFT_NUMBERS = [35, 12, 28, 7, 29, 18, 22, 9, 31, 14, 20, 1, 33, 16, 24];
const ONLINE_RACETRACK_RIGHT_NUMBERS = [15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30];
const ONLINE_RACETRACK_BOTTOM_NUMBERS = [5, 10, 23, 8];
const ONLINE_RACETRACK_SPECIAL_BOUNDARIES = [
  { left: 0, right: 0 },
  { left: (2 / 15) * 100, right: (1 / 14) * 100 },
  { left: (7 / 15) * 100, right: (6 / 14) * 100 },
  { left: (12 / 15) * 100, right: (9 / 14) * 100 },
  { left: 100, right: 100 },
];
const ONLINE_RACETRACK_SPECIAL_BETS = [
  { key: 'ZEROSPIEL', label: 'Zero' },
  { key: 'VOISINS', label: 'Voisins' },
  { key: 'ORPHELINS', label: 'Orphelins' },
  { key: 'TIERS', label: 'Tiers' },
].map((bet, index) => {
  const top = ONLINE_RACETRACK_SPECIAL_BOUNDARIES[index];
  const bottom = ONLINE_RACETRACK_SPECIAL_BOUNDARIES[index + 1];

  return {
    ...bet,
    clipPath: `polygon(0 ${top.left}%, 100% ${top.right}%, 100% ${bottom.right}%, 0 ${bottom.left}%)`,
    labelTop: (top.left + top.right + bottom.left + bottom.right) / 4,
  };
});
const ONLINE_RACETRACK_ARC_ANGLES = [
  [180, 135],
  [135, 90],
  [90, 45],
  [45, 0],
];
const ONLINE_RACETRACK_ARC_WIDTH = 260;
const ONLINE_RACETRACK_ARC_HEIGHT = 143;
const ONLINE_RACETRACK_ARC_CENTER_X = ONLINE_RACETRACK_ARC_WIDTH / 2;
const ONLINE_RACETRACK_ARC_OUTER_RADIUS = { x: 130, y: 143 };
const ONLINE_RACETRACK_ARC_INNER_RADIUS = { x: 78, y: 91 };
const formatRacetrackArcPoint = ({ x, y }) => `${x.toFixed(2)} ${y.toFixed(2)}`;

const getRacetrackArcPoint = (angle, radius, position) => {
  const radians = angle * (Math.PI / 180);
  const isBottom = position === 'bottom';
  const centerY = isBottom ? 0 : ONLINE_RACETRACK_ARC_HEIGHT;

  return {
    x: ONLINE_RACETRACK_ARC_CENTER_X + radius.x * Math.cos(radians),
    y: centerY + (isBottom ? 1 : -1) * radius.y * Math.sin(radians),
  };
};

const getRacetrackArcSegments = (position) => ONLINE_RACETRACK_ARC_ANGLES.map(([startAngle, endAngle]) => {
  const outerStart = getRacetrackArcPoint(startAngle, ONLINE_RACETRACK_ARC_OUTER_RADIUS, position);
  const outerEnd = getRacetrackArcPoint(endAngle, ONLINE_RACETRACK_ARC_OUTER_RADIUS, position);
  const innerEnd = getRacetrackArcPoint(endAngle, ONLINE_RACETRACK_ARC_INNER_RADIUS, position);
  const innerStart = getRacetrackArcPoint(startAngle, ONLINE_RACETRACK_ARC_INNER_RADIUS, position);
  const label = getRacetrackArcPoint(
    (startAngle + endAngle) / 2,
    { x: 104, y: 117 },
    position
  );
  const chip = label;
  const outerSweep = position === 'bottom' ? 0 : 1;
  const innerSweep = position === 'bottom' ? 1 : 0;

  return {
    chip,
    label,
    path: [
      `M ${formatRacetrackArcPoint(outerStart)}`,
      `A ${ONLINE_RACETRACK_ARC_OUTER_RADIUS.x} ${ONLINE_RACETRACK_ARC_OUTER_RADIUS.y} 0 0 ${outerSweep} ${formatRacetrackArcPoint(outerEnd)}`,
      `L ${formatRacetrackArcPoint(innerEnd)}`,
      `A ${ONLINE_RACETRACK_ARC_INNER_RADIUS.x} ${ONLINE_RACETRACK_ARC_INNER_RADIUS.y} 0 0 ${innerSweep} ${formatRacetrackArcPoint(innerStart)}`,
      'Z',
    ].join(' '),
  };
});

const getRacetrackArcBorders = (position) => {
  const angles = [180, 135, 90, 45, 0];
  const sweep = position === 'bottom' ? 0 : 1;
  const outerPoints = angles.map(angle => getRacetrackArcPoint(angle, ONLINE_RACETRACK_ARC_OUTER_RADIUS, position));
  const innerPoints = angles.map(angle => getRacetrackArcPoint(angle, ONLINE_RACETRACK_ARC_INNER_RADIUS, position));
  const buildArcPath = (points, radius) => [
    `M ${formatRacetrackArcPoint(points[0])}`,
    ...points.slice(1).map(point => (
      `A ${radius.x} ${radius.y} 0 0 ${sweep} ${formatRacetrackArcPoint(point)}`
    )),
  ].join(' ');

  return {
    outerPath: buildArcPath(outerPoints, ONLINE_RACETRACK_ARC_OUTER_RADIUS),
    innerPath: buildArcPath(innerPoints, ONLINE_RACETRACK_ARC_INNER_RADIUS),
    dividers: outerPoints.map((point, index) => (
      `M ${formatRacetrackArcPoint(point)} L ${formatRacetrackArcPoint(innerPoints[index])}`
    )),
  };
};

const ONLINE_RACETRACK_ARC_SEGMENTS = {
  top: getRacetrackArcSegments('top'),
  bottom: getRacetrackArcSegments('bottom'),
};
const ONLINE_RACETRACK_ARC_BORDERS = {
  top: getRacetrackArcBorders('top'),
  bottom: getRacetrackArcBorders('bottom'),
};
const ONLINE_RACETRACK_CAP_SPECIAL_PATHS = {
  top: 'M 52 143 A 78 91 0 0 1 208 143 L 208 145 L 52 145 Z',
  bottom: 'M 52 0 A 78 91 0 0 0 208 0 L 208 -2 L 52 -2 Z',
};
const ONLINE_RACETRACK_BOARD_CAP_HEIGHT = 85;
const ONLINE_RACETRACK_BOARD_BODY_HEIGHT = 500;
const ONLINE_RACETRACK_BOARD_HEIGHT = (ONLINE_RACETRACK_BOARD_CAP_HEIGHT * 2) + ONLINE_RACETRACK_BOARD_BODY_HEIGHT;
const ONLINE_RACETRACK_MERGED_ARC_RADIUS_Y = (ONLINE_RACETRACK_ARC_INNER_RADIUS.y / ONLINE_RACETRACK_ARC_HEIGHT) * ONLINE_RACETRACK_BOARD_CAP_HEIGHT;
const ONLINE_RACETRACK_SPECIAL_CHIP_POSITIONS = ONLINE_RACETRACK_SPECIAL_BETS.map(({ key, labelTop }) => ({
  key,
  top: ((ONLINE_RACETRACK_BOARD_CAP_HEIGHT + ((labelTop / 100) * ONLINE_RACETRACK_BOARD_BODY_HEIGHT)) / ONLINE_RACETRACK_BOARD_HEIGHT) * 100,
}));
const ONLINE_RACETRACK_MERGED_SPECIALS = [
  {
    key: 'ZEROSPIEL',
    label: 'Zero',
    path: [
      `M 52 ${ONLINE_RACETRACK_BOARD_CAP_HEIGHT + ((2 / 15) * ONLINE_RACETRACK_BOARD_BODY_HEIGHT)}`,
      `L 52 ${ONLINE_RACETRACK_BOARD_CAP_HEIGHT}`,
      `A 78 ${ONLINE_RACETRACK_MERGED_ARC_RADIUS_Y} 0 0 1 208 ${ONLINE_RACETRACK_BOARD_CAP_HEIGHT}`,
      `L 208 ${ONLINE_RACETRACK_BOARD_CAP_HEIGHT + ((1 / 14) * ONLINE_RACETRACK_BOARD_BODY_HEIGHT)}`,
      'Z',
    ].join(' '),
  },
  {
    key: 'TIERS',
    label: 'Tiers',
    path: [
      `M 52 ${ONLINE_RACETRACK_BOARD_CAP_HEIGHT + ((12 / 15) * ONLINE_RACETRACK_BOARD_BODY_HEIGHT)}`,
      `L 52 ${ONLINE_RACETRACK_BOARD_CAP_HEIGHT + ONLINE_RACETRACK_BOARD_BODY_HEIGHT}`,
      `A 78 ${ONLINE_RACETRACK_MERGED_ARC_RADIUS_Y} 0 0 0 208 ${ONLINE_RACETRACK_BOARD_CAP_HEIGHT + ONLINE_RACETRACK_BOARD_BODY_HEIGHT}`,
      `L 208 ${ONLINE_RACETRACK_BOARD_CAP_HEIGHT + ((9 / 14) * ONLINE_RACETRACK_BOARD_BODY_HEIGHT)}`,
      'Z',
    ].join(' '),
  },
];
const ONLINE_GAME_SESSION_STATE_FIELDS = [
  'isLoaded',
  'betsLogL',
  'betsLogR',
  'luckyArrL',
  'luckyArrR',
  'hot1',
  'hot2',
  'hot3',
  'hot4',
  'hot5',
  'cold1',
  'cold2',
  'cold3',
  'cold4',
  'cold5',
  'currentSpinId',
  'timer',
  'progressPerc',
  'bgTimer',
  'wheelInfoTxt',
  'winners',
  'megaJackpot',
  'miniJackpot',
  'luckyNumberText',
  'betDenomination',
  'betsMap',
  'betsTotal',
  'pendingRoundBetAmount',
  'playerAuthStatus',
  'playerAuthError',
  'playerTokenHash',
  'playerSession',
  'onlinePlayer',
  'onlinePlayerBalance',
  'onlinePlayerShop',
  'bettingShopID',
  'agentID',
  'gameID',
  'gameSpinNumber',
  'isBettingTableExpanded',
  'isRacetrackView',
];

const getOnlineGameSessionState = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return {};
  }

  try {
    const storedState = window.sessionStorage.getItem(ONLINE_GAME_SESSION_STATE_KEY);
    const parsedState = storedState ? JSON.parse(storedState) : {};
    const launchToken = getOnlineLaunchTokenFromUrl();
    const cachedLaunchToken = parsedState?.playerSession?.launchToken || '';

    if (
      !parsedState ||
      typeof parsedState !== 'object' ||
      parsedState.playerAuthStatus === 'failed' ||
      !launchToken ||
      (cachedLaunchToken && cachedLaunchToken !== launchToken) ||
      isPlayerSessionExpired(parsedState.playerSession)
    ) {
      return {};
    }

    if (window.sessionStorage.getItem(ONLINE_FORCE_WHEEL_VIEW_KEY)) {
      window.sessionStorage.removeItem(ONLINE_FORCE_WHEEL_VIEW_KEY);
      parsedState.isBettingTableExpanded = false;
    }

    return parsedState;
  } catch (error) {
    return {};
  }
};

const setOnlineGameSessionState = (state) => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }

  window.sessionStorage.setItem(ONLINE_GAME_SESSION_STATE_KEY, JSON.stringify(state));
};

const clearOnlineGameSessionState = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }

  window.sessionStorage.removeItem(ONLINE_GAME_SESSION_STATE_KEY);
};

const ONLINE_CHIP_VALUES = [20, 50, 100, 500, 1000, 2000, 5000];
const BETTING_TABLE_ANIMATION_MS = 320;
const ONLINE_WIN_COINS = [
  { left: 7, delay: 40, duration: 2550, drift: 24, spin: 920, tilt: 64, scale: 0.72 },
  { left: 16, delay: 420, duration: 2780, drift: -18, spin: -1080, tilt: 76, scale: 1.08 },
  { left: 24, delay: 120, duration: 3040, drift: 42, spin: 1260, tilt: 58, scale: 0.84 },
  { left: 33, delay: 680, duration: 2480, drift: -26, spin: -900, tilt: 72, scale: 0.62 },
  { left: 42, delay: 260, duration: 2860, drift: 18, spin: 1120, tilt: 82, scale: 0.92 },
  { left: 51, delay: 820, duration: 2420, drift: -35, spin: -980, tilt: 68, scale: 0.7 },
  { left: 60, delay: 80, duration: 3140, drift: 28, spin: 1320, tilt: 60, scale: 1.14 },
  { left: 69, delay: 540, duration: 2660, drift: -22, spin: -1160, tilt: 78, scale: 0.8 },
  { left: 78, delay: 190, duration: 2920, drift: 34, spin: 1040, tilt: 66, scale: 1.02 },
  { left: 88, delay: 760, duration: 2520, drift: -30, spin: -1240, tilt: 74, scale: 0.68 },
  { left: 95, delay: 330, duration: 2820, drift: -42, spin: 960, tilt: 56, scale: 0.9 },
  { left: 12, delay: 940, duration: 2320, drift: 36, spin: -880, tilt: 80, scale: 0.6 },
  { left: 28, delay: 1030, duration: 2440, drift: -20, spin: 1180, tilt: 62, scale: 0.76 },
  { left: 47, delay: 1120, duration: 2260, drift: 30, spin: -1020, tilt: 70, scale: 0.66 },
  { left: 72, delay: 980, duration: 2380, drift: -38, spin: 1280, tilt: 84, scale: 0.86 },
  { left: 91, delay: 1080, duration: 2300, drift: 20, spin: -1100, tilt: 64, scale: 0.64 },
];

const getOnlineBettingTimeRemaining = (timerSeconds) => Math.min(
  Math.max(ONLINE_AUTO_BET_SUBMIT_START - timerSeconds, 0),
  ONLINE_AUTO_BET_SUBMIT_START
);

const getOnlineProgressTimeRemaining = (bettingTimeRemaining) => (
  Math.max(bettingTimeRemaining - 1, 0)
);

const getOnlineProgressPercentage = (progressTimeRemaining) => Math.min(
  Math.max((progressTimeRemaining / ONLINE_PROGRESS_DURATION_SECONDS) * 97, 0),
  97
);

const formatOnlineChipLabel = (value) => {
  if (value >= 1000) {
    return `${value / 1000}K`;
  }

  return value;
};

const numberRows = [
  [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
  [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
  [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34],
];

const rotatedNumberRows = Array.from({ length: 12 }, (_, index) => [
  index * 3 + 1,
  index * 3 + 2,
  index * 3 + 3,
]);
const horizontalNumberColumns = rotatedNumberRows.map(row => [...row].reverse());

const normalizeBetNumbers = (numbers = []) => numbers
  .map(number => String(number))
  .sort((left, right) => Number(left) - Number(right))
  .join('|');

const crossBetKeyByNumbers = Object.entries(betmap).reduce((lookup, [betKey, bet]) => {
  if (/^(SPLIT|STREET|CORNER|SIXLINE)/.test(betKey) && Array.isArray(bet.numbers)) {
    lookup[normalizeBetNumbers(bet.numbers)] = betKey;
  }

  return lookup;
}, {});

const createCrossBetTargets = () => {
  const targets = [];
  const addTarget = (type, numbers, left, top, axis = '') => {
    const betKey = crossBetKeyByNumbers[normalizeBetNumbers(numbers)];

    if (betKey) {
      targets.push({ type, axis, numbers, betKey, left, top });
    }
  };

  rotatedNumberRows.forEach((row, rowIndex) => {
    row.slice(0, -1).forEach((number, columnIndex) => {
      addTarget(
        'split',
        [number, row[columnIndex + 1]],
        ((columnIndex + 1) / row.length) * 100,
        ((rowIndex + 0.5) / rotatedNumberRows.length) * 100,
        'column'
      );
    });

    addTarget(
      'street',
      row,
      0,
      ((rowIndex + 0.5) / rotatedNumberRows.length) * 100
    );

    if (rowIndex === rotatedNumberRows.length - 1) {
      return;
    }

    const nextRow = rotatedNumberRows[rowIndex + 1];

    row.forEach((number, columnIndex) => {
      addTarget(
        'split',
        [number, nextRow[columnIndex]],
        ((columnIndex + 0.5) / row.length) * 100,
        ((rowIndex + 1) / rotatedNumberRows.length) * 100,
        'row'
      );
    });

    row.slice(0, -1).forEach((number, columnIndex) => {
      addTarget(
        'corner',
        [number, row[columnIndex + 1], nextRow[columnIndex], nextRow[columnIndex + 1]],
        ((columnIndex + 1) / row.length) * 100,
        ((rowIndex + 1) / rotatedNumberRows.length) * 100
      );
    });

    addTarget(
      'six-line',
      [...row, ...nextRow],
      0,
      ((rowIndex + 1) / rotatedNumberRows.length) * 100
    );
  });

  if (betmap.FIRSTFOUR) {
    targets.push({
      type: 'first-four',
      axis: '',
      numbers: betmap.FIRSTFOUR.numbers,
      betKey: 'FIRSTFOUR',
      left: 0,
      top: 0,
    });
  }

  return targets;
};

const ONLINE_CROSS_BET_TARGETS = createCrossBetTargets();
const createHorizontalCrossBetTargets = () => {
  const targets = [];
  const addTarget = (type, numbers, left, top, axis = '') => {
    const betKey = crossBetKeyByNumbers[normalizeBetNumbers(numbers)];

    if (betKey) {
      targets.push({ type, axis, numbers, betKey, left, top });
    }
  };

  horizontalNumberColumns.forEach((column, columnIndex) => {
    column.slice(0, -1).forEach((number, rowIndex) => {
      addTarget(
        'split',
        [number, column[rowIndex + 1]],
        ((columnIndex + 0.5) / horizontalNumberColumns.length) * 100,
        ((rowIndex + 1) / column.length) * 100,
        'row'
      );
    });

    addTarget(
      'street',
      column,
      ((columnIndex + 0.5) / horizontalNumberColumns.length) * 100,
      100
    );

    if (columnIndex === horizontalNumberColumns.length - 1) {
      return;
    }

    const nextColumn = horizontalNumberColumns[columnIndex + 1];

    column.forEach((number, rowIndex) => {
      addTarget(
        'split',
        [number, nextColumn[rowIndex]],
        ((columnIndex + 1) / horizontalNumberColumns.length) * 100,
        ((rowIndex + 0.5) / column.length) * 100,
        'column'
      );
    });

    column.slice(0, -1).forEach((number, rowIndex) => {
      addTarget(
        'corner',
        [number, column[rowIndex + 1], nextColumn[rowIndex], nextColumn[rowIndex + 1]],
        ((columnIndex + 1) / horizontalNumberColumns.length) * 100,
        ((rowIndex + 1) / column.length) * 100
      );
    });

    addTarget(
      'six-line',
      [...column, ...nextColumn],
      ((columnIndex + 1) / horizontalNumberColumns.length) * 100,
      100
    );
  });

  if (betmap.FIRSTFOUR) {
    targets.push({
      type: 'first-four',
      axis: '',
      numbers: betmap.FIRSTFOUR.numbers,
      betKey: 'FIRSTFOUR',
      left: 0,
      top: 100,
    });
  }

  return targets;
};
const ONLINE_HORIZONTAL_CROSS_BET_TARGETS = createHorizontalCrossBetTargets();
const CROSS_BET_LABELS = {
  split: 'Split',
  street: 'Street',
  corner: 'Corner',
  'six-line': 'Six line',
  'first-four': 'First four',
};

const outsideBets = [
  { key: 'LOW', label: '1-18' },
  { key: 'EVEN', label: 'Even' },
  { key: 'HIGH', label: '19-36' },
];

const finalOutsideBets = [
  { key: 'RED', label: 'Red' },
  { key: 'ODD', label: 'Odd' },
  { key: 'BLACK', label: 'Black' },
];

const columnBets = [
  { key: 'COLUMN1', label: 'C1' },
  { key: 'COLUMN2', label: 'C2' },
  { key: 'COLUMN3', label: 'C3' },
];

const specialBetRows = [
  [
    { key: 'REDSPLIT', label: 'Red Split' },
    { key: 'BLACKSPLIT', label: 'Blk Split' },
    { key: 'ZEROSPIEL', label: 'Zero Spiel' },
  ],
  [
    { key: 'SNAKE', label: 'Snake' },
    { key: 'ORPHELINS', label: 'Orphelins' },
    { key: 'TIERS', label: 'Tiers' },
    { key: 'VOISINS', label: 'Voisins' },
  ],
];

const dozenBets = [
  { key: 'DOZEN1', label: '1st 12' },
  { key: 'DOZEN2', label: '2nd 12' },
  { key: 'DOZEN3', label: '3rd 12' },
];

class OnlineWheelPageSZJP extends WheelPageSZJP {
  getRoundDurationSeconds() {
    return ONLINE_ROUND_SECONDS;
  }

  getSpinEntryLockSeconds() {
    return ONLINE_SPIN_ENTRY_LOCK_SECONDS;
  }

  getWinningNumberAnnouncementDelayMs() {
    return super.getWinningNumberAnnouncementDelayMs() + 2000;
  }

  previousAxiosAuthorization = undefined;
  previousAxiosTokenHash = undefined;
  restoredOnlineGameSessionState = getOnlineGameSessionState();
  lastOnlineGameSessionState = '';
  noopAudioPlay = () => Promise.resolve();
  bettingTableAnimationTimer = null;
  desktopSplitMediaQuery = null;
  largeDesktopMediaQuery = null;
  viewportLayoutFrame = null;
  betNotificationTimer = null;
  balanceRefreshTimer = null;
  balanceAnimationFrame = null;
  winCelebrationTimer = null;
  winAudioRef = React.createRef();
  congratsWinAudioRef = React.createRef();
  backgroundMusicAudio = null;
  chipPlacementAudio = null;
  backgroundMusicUnlockListenersAttached = false;
  isBackgroundMusicStarting = false;
  backgroundMusicPlayAttempt = 0;
  confirmedOnlinePlayerBalance = null;
  isBetSubmissionInFlight = false;
  lastAutomaticBetSpinNumber = '';
  latestOnlineGameID = this.restoredOnlineGameSessionState.gameID || '';
  latestOnlineGameSpinNumber = this.restoredOnlineGameSessionState.gameSpinNumber || '';
  latestOnlineAgentID = this.restoredOnlineGameSessionState.agentID || '';
  onlineWheelIdleAnimation = null;
  onlineWheelPreSpinAnimation = null;
  onlineWheelIdleRestartTimer = null;
  isOnlineWheelSpinAnimating = false;

  state = {
    ...this.state,
    ...this.restoredOnlineGameSessionState,
    betDenomination: ONLINE_CHIP_VALUES.includes(this.restoredOnlineGameSessionState.betDenomination)
      ? this.restoredOnlineGameSessionState.betDenomination
      : 20,
    betsMap: this.restoredOnlineGameSessionState.betsMap || {},
    betsTotal: this.restoredOnlineGameSessionState.betsTotal || 0,
    pendingRoundBetAmount: Number(this.restoredOnlineGameSessionState.pendingRoundBetAmount) || 0,
    betMessage: '',
    isSubmittingBet: false,
    playerAuthStatus: this.restoredOnlineGameSessionState.playerAuthStatus || 'authenticating',
    playerAuthError: this.restoredOnlineGameSessionState.playerAuthError || '',
    playerAuthCanRetry: false,
    playerTokenHash: this.restoredOnlineGameSessionState.playerTokenHash || '',
    playerSession: this.restoredOnlineGameSessionState.playerSession || null,
    onlinePlayer: this.restoredOnlineGameSessionState.onlinePlayer || null,
    onlinePlayerBalance: this.restoredOnlineGameSessionState.onlinePlayerBalance || null,
    onlinePlayerShop: this.restoredOnlineGameSessionState.onlinePlayerShop || null,
    agentID: this.restoredOnlineGameSessionState.agentID || '',
    gameID: this.restoredOnlineGameSessionState.gameID || '',
    gameSpinNumber: this.restoredOnlineGameSessionState.gameSpinNumber || '',
    isAutoBetCutoffActive: false,
    isSpinEntryLocked: false,
    isBettingTableExpanded: Boolean(this.restoredOnlineGameSessionState.isBettingTableExpanded),
    isRacetrackView: Boolean(this.restoredOnlineGameSessionState.isRacetrackView),
    isDesktopSplitLayout: typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia(ONLINE_DESKTOP_SPLIT_LAYOUT_QUERY).matches,
    isLargeDesktopLayout: typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia(ONLINE_LARGE_DESKTOP_LAYOUT_QUERY).matches,
    isBettingTableClosing: false,
    isBetEraseMode: false,
    betNotification: '',
    hoveredCrossBetKey: '',
    winCelebration: null,
  };

  baseSpinWheel = this.spinWheel;

  getOnlineWheelLayers = () => {
    if (typeof document === 'undefined') {
      return [];
    }

    return Array.from(document.querySelectorAll(
      '.online-wheel-page .roulette-wheel .layer-2, .online-wheel-page .roulette-wheel .layer-4'
    ));
  };

  getOnlineWheelBalls = () => {
    if (typeof document === 'undefined') {
      return [];
    }

    return Array.from(document.querySelectorAll('.online-wheel-page .roulette-wheel .ball'));
  };

  setOnlineWheelIdleBallsHidden = (isHidden) => {
    const balls = this.getOnlineWheelBalls();

    balls.forEach((ball) => {
      ball.classList.toggle('online-wheel-ball--idle-hidden', isHidden);
    });

    if (isHidden) {
      anime.set(balls, { opacity: 0 });
    }
  };

  clearOnlineWheelIdleRestart = () => {
    if (this.onlineWheelIdleRestartTimer) {
      clearTimeout(this.onlineWheelIdleRestartTimer);
      this.onlineWheelIdleRestartTimer = null;
    }
  };

  stopOnlineWheelIdleSpin = () => {
    if (this.onlineWheelIdleAnimation) {
      this.onlineWheelIdleAnimation.pause();
      this.onlineWheelIdleAnimation = null;
    }
  };

  stopOnlineWheelPreSpin = () => {
    if (this.onlineWheelPreSpinAnimation) {
      this.onlineWheelPreSpinAnimation.pause();
      this.onlineWheelPreSpinAnimation = null;
    }
  };

  stopOnlineWheelMotion = ({ removeAnimations = false } = {}) => {
    this.clearOnlineWheelIdleRestart();
    this.stopOnlineWheelIdleSpin();
    this.stopOnlineWheelPreSpin();

    if (removeAnimations && typeof document !== 'undefined') {
      this.setOnlineWheelIdleBallsHidden(false);
      anime.remove(document.querySelectorAll(
        '.online-wheel-page .roulette-wheel .layer-2, '
        + '.online-wheel-page .roulette-wheel .layer-4, '
        + '.online-wheel-page .roulette-wheel .ball-container, '
        + '.online-wheel-page .roulette-wheel .ball'
      ));
    }
  };

  startOnlineWheelIdleSpin = () => {
    this.clearOnlineWheelIdleRestart();

    const prefersReducedMotion = typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (
      !this.isOnlineWheelMounted
      || this.isOnlineWheelSpinAnimating
      || this.state.playerAuthStatus === 'failed'
    ) {
      return;
    }

    this.setOnlineWheelIdleBallsHidden(true);

    if (prefersReducedMotion) {
      return;
    }

    const wheelLayers = this.getOnlineWheelLayers();
    if (!wheelLayers.length) {
      return;
    }

    this.stopOnlineWheelIdleSpin();
    this.onlineWheelIdleAnimation = anime({
      targets: wheelLayers,
      rotate: '+=360',
      duration: ONLINE_IDLE_WHEEL_TURN_MS,
      easing: 'linear',
      loop: true,
    });
  };

  scheduleOnlineWheelIdleSpin = (delay = 0) => {
    this.clearOnlineWheelIdleRestart();
    this.onlineWheelIdleRestartTimer = setTimeout(() => {
      this.onlineWheelIdleRestartTimer = null;
      this.startOnlineWheelIdleSpin();
    }, delay);
  };

  beforeSpinWheel = () => {
    this.clearOnlineWheelIdleRestart();
    this.stopOnlineWheelIdleSpin();
    this.stopOnlineWheelPreSpin();

    const wheelLayers = this.getOnlineWheelLayers();
    this.setOnlineWheelIdleBallsHidden(true);

    if (!wheelLayers.length) {
      return;
    }

    const preSpinAnimation = anime({
      targets: wheelLayers,
      rotate: (target) => {
        const currentRotation = Number.parseFloat(anime.get(target, 'rotate')) || 0;
        const alignedRotation = Math.round((currentRotation + 720) / 360) * 360;
        return alignedRotation > currentRotation ? alignedRotation : alignedRotation + 360;
      },
      duration: ONLINE_PRE_SPIN_DURATION_MS,
      easing: 'linear',
      complete: () => {
        if (this.onlineWheelPreSpinAnimation === preSpinAnimation) {
          this.onlineWheelPreSpinAnimation = null;
        }
      },
    });

    this.onlineWheelPreSpinAnimation = preSpinAnimation;
  };

  persistOnlineGameSessionState = () => {
    if (this.state.playerAuthStatus === 'failed') {
      clearOnlineGameSessionState();
      return;
    }

    const snapshot = ONLINE_GAME_SESSION_STATE_FIELDS.reduce((nextSnapshot, field) => {
      nextSnapshot[field] = this.state[field];
      return nextSnapshot;
    }, {});

    try {
      const serializedSnapshot = JSON.stringify(snapshot);

      if (serializedSnapshot === this.lastOnlineGameSessionState) {
        return;
      }

      setOnlineGameSessionState({
        ...snapshot,
        savedAt: Date.now(),
      });
      this.lastOnlineGameSessionState = serializedSnapshot;
    } catch (error) {
      // Session cache is a convenience only; live socket state remains the source of truth.
    }
  };

  getOnlineWheelAudioPlayers = () => {
    const renderedAudioPlayers = typeof document === 'undefined'
      ? []
      : Array.from(document.querySelectorAll('.online-wheel-page audio'));

    return Array.from(new Set([
      this.placeYourBetsAudio,
      this.placeYourBetsAudioNoBets,
      this.placeBetsClosAudio,
      this.ballRollingAudio,
      this.ballRollingAudioEnd,
      ...Array.from({ length: 37 }, (_, number) => this[`numberAudio${number}`]),
      this.ballAudioRef?.current,
      this.winAudioRef?.current,
      this.congratsWinAudioRef?.current,
      this.backgroundMusicAudio,
      this.chipPlacementAudio,
      ...renderedAudioPlayers,
    ].filter(Boolean)));
  };

  addBackgroundMusicUnlockListeners = () => {
    if (this.backgroundMusicUnlockListenersAttached || typeof document === 'undefined') {
      return;
    }

    document.addEventListener('pointerdown', this.handleBackgroundMusicUnlock, { passive: true });
    document.addEventListener('touchstart', this.handleBackgroundMusicUnlock, { passive: true });
    document.addEventListener('keydown', this.handleBackgroundMusicUnlock);
    this.backgroundMusicUnlockListenersAttached = true;
  };

  removeBackgroundMusicUnlockListeners = () => {
    if (!this.backgroundMusicUnlockListenersAttached || typeof document === 'undefined') {
      return;
    }

    document.removeEventListener('pointerdown', this.handleBackgroundMusicUnlock);
    document.removeEventListener('touchstart', this.handleBackgroundMusicUnlock);
    document.removeEventListener('keydown', this.handleBackgroundMusicUnlock);
    this.backgroundMusicUnlockListenersAttached = false;
  };

  handleBackgroundMusicUnlock = () => {
    // A pending autoplay request must not consume the first valid user gesture.
    this.removeBackgroundMusicUnlockListeners();
    this.startBackgroundMusic({ force: true });
  };

  startBackgroundMusic = ({ force = false } = {}) => {
    const audio = this.backgroundMusicAudio;

    if (
      !audio
      || this.isMuted
      || !this.isOnlineWheelMounted
      || (this.isBackgroundMusicStarting && !force)
    ) {
      return;
    }

    if (!audio.paused) {
      this.isBackgroundMusicStarting = false;
      this.removeBackgroundMusicUnlockListeners();
      return;
    }

    const playAttempt = ++this.backgroundMusicPlayAttempt;

    try {
      audio.muted = false;
      audio.volume = ONLINE_BACKGROUND_MUSIC_VOLUME;
      const playback = audio.play();

      if (playback?.then) {
        this.isBackgroundMusicStarting = true;
        playback
          .then(() => {
            if (playAttempt !== this.backgroundMusicPlayAttempt) {
              return;
            }

            this.isBackgroundMusicStarting = false;
            this.removeBackgroundMusicUnlockListeners();
          })
          .catch(() => {
            if (playAttempt !== this.backgroundMusicPlayAttempt) {
              return;
            }

            this.isBackgroundMusicStarting = false;
            if (this.isOnlineWheelMounted && !this.isMuted) {
              this.addBackgroundMusicUnlockListeners();
            }
          });
      } else {
        this.removeBackgroundMusicUnlockListeners();
      }
    } catch (error) {
      this.isBackgroundMusicStarting = false;
      if (this.isOnlineWheelMounted && !this.isMuted) {
        this.addBackgroundMusicUnlockListeners();
      }
    }
  };

  initializeBackgroundMusic = () => {
    if (this.backgroundMusicAudio || typeof Audio === 'undefined') {
      return;
    }

    this.backgroundMusicAudio = new Audio(casinoBackgroundMusic);
    this.backgroundMusicAudio.loop = true;
    this.backgroundMusicAudio.preload = 'auto';
    this.backgroundMusicAudio.volume = ONLINE_BACKGROUND_MUSIC_VOLUME;
    this.backgroundMusicAudio.muted = this.isMuted;
    this.addBackgroundMusicUnlockListeners();
    this.startBackgroundMusic();
  };

  initializeChipPlacementAudio = () => {
    if (this.chipPlacementAudio || typeof Audio === 'undefined') {
      return;
    }

    this.chipPlacementAudio = new Audio(chipPlacementSound);
    this.chipPlacementAudio.preload = 'auto';
    this.chipPlacementAudio.volume = ONLINE_CHIP_PLACEMENT_VOLUME;
    this.chipPlacementAudio.muted = this.isMuted;
  };

  playChipPlacementSound = () => {
    const audio = this.chipPlacementAudio;

    if (!audio || this.isMuted) {
      return;
    }

    try {
      audio.pause();
      audio.currentTime = 0;
      audio.muted = false;
      audio.volume = ONLINE_CHIP_PLACEMENT_VOLUME;
      const playback = audio.play();

      if (playback?.catch) {
        playback.catch(() => {});
      }
    } catch (error) {
      // A failed sound effect must never interrupt bet placement.
    }
  };

  setOnlineWheelAudioMuted = (isMuted, { stopPlayback = isMuted } = {}) => {
    this.getOnlineWheelAudioPlayers().forEach((audio) => {
      try {
        audio.muted = isMuted;

        if (stopPlayback) {
          audio.pause();
          audio.currentTime = 0;
        }
      } catch (error) {
        // Ignore media elements that are changing source during a round transition.
      }
    });
  };

  toggleMute = () => {
    this.isMuted = !this.isMuted;

    if (this.isMuted) {
      this.backgroundMusicPlayAttempt += 1;
      this.isBackgroundMusicStarting = false;
      this.removeBackgroundMusicUnlockListeners();
    }

    // Stop silently running clips too, so unmuting never resumes one mid-sentence.
    this.setOnlineWheelAudioMuted(this.isMuted, { stopPlayback: true });

    if (!this.isMuted) {
      this.startBackgroundMusic();
    }

    this.forceUpdate();
  };

  stopOnlineWheelAudio = ({ blockFuturePlay = false } = {}) => {
    this.getOnlineWheelAudioPlayers().forEach((audio) => {
      try {
        audio.pause();
        audio.currentTime = 0;
        audio.muted = true;

        if (blockFuturePlay) {
          audio.play = this.noopAudioPlay;
        }
      } catch (error) {
        // Ignore browser audio state errors during route transitions.
      }
    });
  };

  stopOnlineWheelRuntime = ({ blockFuturePlay = false } = {}) => {
    this.isOnlineWheelSpinAnimating = false;
    this.stopOnlineWheelMotion({ removeAnimations: true });
    this.stopOnlineWheelAudio({ blockFuturePlay });

    if (this.socketServer) {
      this.socketServer.close();
      this.socketServer = null;
    }
  };

  async componentDidMount() {
    this.isOnlineWheelMounted = true;
    document.body.classList.add('online-wheel-active');
    this.syncOnlineViewportMetrics();
    window.addEventListener('resize', this.scheduleOnlineViewportSync, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.scheduleOnlineViewportSync, { passive: true });
    }
    this.initializeChipPlacementAudio();
    this.initializeBackgroundMusic();
    window.addEventListener(ONLINE_FORCE_WHEEL_VIEW_EVENT, this.forceWheelView);
    this.desktopSplitMediaQuery = typeof window.matchMedia === 'function'
      ? window.matchMedia(ONLINE_DESKTOP_SPLIT_LAYOUT_QUERY)
      : null;
    this.largeDesktopMediaQuery = typeof window.matchMedia === 'function'
      ? window.matchMedia(ONLINE_LARGE_DESKTOP_LAYOUT_QUERY)
      : null;

    if (this.desktopSplitMediaQuery?.addEventListener) {
      this.desktopSplitMediaQuery.addEventListener('change', this.handleDesktopSplitLayoutChange);
    } else if (this.desktopSplitMediaQuery) {
      this.desktopSplitMediaQuery.addListener(this.handleDesktopSplitLayoutChange);
    }

    if (this.largeDesktopMediaQuery?.addEventListener) {
      this.largeDesktopMediaQuery.addEventListener('change', this.handleLargeDesktopLayoutChange);
    } else if (this.largeDesktopMediaQuery) {
      this.largeDesktopMediaQuery.addListener(this.handleLargeDesktopLayoutChange);
    }

    if (window.sessionStorage.getItem(ONLINE_FORCE_WHEEL_VIEW_KEY)) {
      window.sessionStorage.removeItem(ONLINE_FORCE_WHEEL_VIEW_KEY);
      this.forceWheelView();
    }

    if (this.state.playerTokenHash && this.state.playerAuthStatus !== 'failed') {
      this.setAxiosAuthorizationHeader(this.state.playerTokenHash);
    }

    if (this.state.playerAuthStatus === 'failed') {
      this.stopOnlineWheelRuntime({ blockFuturePlay: true });
      return;
    }

    const isAuthenticated = await this.authenticateOnlinePlayer();
    if (!isAuthenticated || !this.isOnlineWheelMounted) {
      return;
    }

    await super.componentDidMount();
    this.scheduleOnlineViewportSync();
    this.scheduleOnlineWheelIdleSpin();

    if (this.socketServer) {
      this.socketServer.on('game', this.syncOnlineGameMeta);
      this.socketServer.on('timer', this.syncOnlineGameMeta);
    }

    this.persistOnlineGameSessionState();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.playerAuthStatus === 'failed') {
      if (prevState.playerAuthStatus !== 'failed') {
        this.stopOnlineWheelRuntime({ blockFuturePlay: true });
      }
      clearOnlineGameSessionState();
      return;
    }

    const wheelSurfaceChanged = prevState.isLoaded !== this.state.isLoaded
      || prevState.isBettingTableExpanded !== this.state.isBettingTableExpanded
      || prevState.isRacetrackView !== this.state.isRacetrackView
      || prevState.isDesktopSplitLayout !== this.state.isDesktopSplitLayout
      || prevState.isLargeDesktopLayout !== this.state.isLargeDesktopLayout;

    if (wheelSurfaceChanged && !this.isOnlineWheelSpinAnimating) {
      this.stopOnlineWheelIdleSpin();
      this.scheduleOnlineWheelIdleSpin();
    }

    if (wheelSurfaceChanged) {
      this.scheduleOnlineViewportSync();
    }

    this.persistOnlineGameSessionState();
  }

  componentWillUnmount() {
    this.isOnlineWheelMounted = false;
    this.isOnlineWheelSpinAnimating = false;
    this.stopOnlineWheelMotion({ removeAnimations: true });
    this.removeBackgroundMusicUnlockListeners();
    window.removeEventListener('resize', this.scheduleOnlineViewportSync);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.scheduleOnlineViewportSync);
    }
    if (this.viewportLayoutFrame && window.cancelAnimationFrame) {
      window.cancelAnimationFrame(this.viewportLayoutFrame);
      this.viewportLayoutFrame = null;
    }
    document.body.style.removeProperty('--online-wheel-viewport-height');
    if (this.desktopSplitMediaQuery) {
      if (this.desktopSplitMediaQuery.removeEventListener) {
        this.desktopSplitMediaQuery.removeEventListener('change', this.handleDesktopSplitLayoutChange);
      } else {
        this.desktopSplitMediaQuery.removeListener(this.handleDesktopSplitLayoutChange);
      }
      this.desktopSplitMediaQuery = null;
    }
    if (this.largeDesktopMediaQuery) {
      if (this.largeDesktopMediaQuery.removeEventListener) {
        this.largeDesktopMediaQuery.removeEventListener('change', this.handleLargeDesktopLayoutChange);
      } else {
        this.largeDesktopMediaQuery.removeListener(this.handleLargeDesktopLayoutChange);
      }
      this.largeDesktopMediaQuery = null;
    }

    if (this.bettingTableAnimationTimer) {
      clearTimeout(this.bettingTableAnimationTimer);
    }

    if (this.betNotificationTimer) {
      clearTimeout(this.betNotificationTimer);
    }

    if (this.balanceRefreshTimer) {
      clearTimeout(this.balanceRefreshTimer);
      this.balanceRefreshTimer = null;
    }

    if (this.balanceAnimationFrame && window.cancelAnimationFrame) {
      window.cancelAnimationFrame(this.balanceAnimationFrame);
      this.balanceAnimationFrame = null;
    }

    if (this.winCelebrationTimer) {
      clearTimeout(this.winCelebrationTimer);
      this.winCelebrationTimer = null;
    }

    this.persistOnlineGameSessionState();
    this.stopOnlineWheelRuntime();
    this.backgroundMusicAudio = null;
    this.chipPlacementAudio = null;
    document.body.classList.remove('online-wheel-active');
    window.removeEventListener(ONLINE_FORCE_WHEEL_VIEW_EVENT, this.forceWheelView);
    this.restoreAxiosAuthorizationHeader();
    super.componentWillUnmount();
  }

  getLaunchTokenFromUrl = () => getOnlineLaunchTokenFromUrl();

  handleDesktopSplitLayoutChange = (event) => {
    this.setState({ isDesktopSplitLayout: event.matches });
  };

  handleLargeDesktopLayoutChange = (event) => {
    this.setState({ isLargeDesktopLayout: event.matches });
  };

  syncOnlineViewportMetrics = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const viewportHeight = window.visualViewport?.height || window.innerHeight;

    if (Number.isFinite(viewportHeight) && viewportHeight > 0) {
      document.body.style.setProperty('--online-wheel-viewport-height', `${viewportHeight}px`);
    }

    const isDesktopSplitLayout = typeof window.matchMedia === 'function'
      && window.matchMedia(ONLINE_DESKTOP_SPLIT_LAYOUT_QUERY).matches;
    const isLargeDesktopLayout = typeof window.matchMedia === 'function'
      && window.matchMedia(ONLINE_LARGE_DESKTOP_LAYOUT_QUERY).matches;

    if (this.isOnlineWheelMounted && (
      this.state.isDesktopSplitLayout !== isDesktopSplitLayout
      || this.state.isLargeDesktopLayout !== isLargeDesktopLayout
    )) {
      this.setState({ isDesktopSplitLayout, isLargeDesktopLayout });
    }
  };

  scheduleOnlineViewportSync = () => {
    if (!window.requestAnimationFrame) {
      this.syncOnlineViewportMetrics();
      return;
    }

    if (this.viewportLayoutFrame) {
      window.cancelAnimationFrame(this.viewportLayoutFrame);
    }

    this.viewportLayoutFrame = window.requestAnimationFrame(() => {
      this.viewportLayoutFrame = null;
      this.syncOnlineViewportMetrics();
    });
  };

  getInitialBalanceFromUrl = () => {
    const rawBalance = new URL(window.location.href).searchParams.get('balance');

    if (rawBalance === null || rawBalance.trim() === '') {
      return undefined;
    }

    const balance = Number(rawBalance);

    if (!Number.isFinite(balance) || balance < 0) {
      throw new Error('Initial balance must be a non-negative number');
    }

    return balance;
  };

  getInitialMemberIdFromUrl = () => {
    const memberId = new URL(window.location.href).searchParams.get('memberId');
    const normalizedMemberId = String(memberId || '').trim();
    return normalizedMemberId || undefined;
  };

  buildApiUrl = (path) => `${API_URL}${path}`;

  isNotFoundError = (error) => error?.response?.status === 404;

  getErrorMessage = (error, fallback) => {
    return error?.response?.data?.message || error?.response?.data?.error || error?.message || fallback;
  };

  postFirstAvailable = async (paths, payload, config = {}) => {
    let lastError;

    for (const path of paths) {
      try {
        return await axios.post(this.buildApiUrl(path), payload, config);
      } catch (error) {
        lastError = error;
        if (!this.isNotFoundError(error)) {
          throw error;
        }
      }
    }

    throw lastError;
  };

  getFirstAvailable = async (paths, config = {}) => {
    let lastError;

    for (const path of paths) {
      try {
        return await axios.get(this.buildApiUrl(path), config);
      } catch (error) {
        lastError = error;
        if (!this.isNotFoundError(error)) {
          throw error;
        }
      }
    }

    throw lastError;
  };

  normalizePlayerSession = (data = {}) => {
    const tokenHash = data.tokenHash || data.session?.tokenHash || '';
    const balance = data.balance
      ?? data.playerBalance
      ?? data.playerSession?.balance
      ?? data.player?.balance
      ?? null;

    return {
      tokenHash,
      playerSessionId: data.playerSessionId || data.playerSession?._id || data.session?._id || '',
      expiredAt: data.expiredAt || data.session?.expiredAt,
      launchToken: data.launchToken || data.session?.launchToken || '',
      memberId: data.memberId || data.playerSession?.memberId || data.session?.memberId || '',
      player: data.player || data.playerSession?.player || null,
      shop: data.shop || data.bettingShop || data.playerSession?.shop || null,
      game: data.game || null,
      balance,
      raw: data,
    };
  };

  setAxiosAuthorizationHeader = (tokenHash) => {
    if (this.previousAxiosAuthorization === undefined) {
      this.previousAxiosAuthorization = axios.defaults.headers.common.Authorization || null;
    }

    if (this.previousAxiosTokenHash === undefined) {
      this.previousAxiosTokenHash = axios.defaults.headers.common['X-Token-Hash'] || null;
    }

    axios.defaults.headers.common.Authorization = `Bearer ${tokenHash}`;
    axios.defaults.headers.common['X-Token-Hash'] = tokenHash;
  };

  restoreAxiosAuthorizationHeader = () => {
    if (this.previousAxiosAuthorization === undefined) {
      return;
    }

    if (this.previousAxiosAuthorization) {
      axios.defaults.headers.common.Authorization = this.previousAxiosAuthorization;
    } else {
      delete axios.defaults.headers.common.Authorization;
    }

    if (this.previousAxiosTokenHash) {
      axios.defaults.headers.common['X-Token-Hash'] = this.previousAxiosTokenHash;
    } else {
      delete axios.defaults.headers.common['X-Token-Hash'];
    }

    this.previousAxiosAuthorization = undefined;
    this.previousAxiosTokenHash = undefined;
  };

  persistPlayerSession = (session) => {
    persistCachedPlayerSession(session);
  };

  clearPersistedPlayerSession = () => {
    clearCachedPlayerSession();
  };

  getStoredPlayerSession = () => getCachedPlayerSession();

  getNormalizedBalanceValue = (value, fallback = ONLINE_BALANCE_INITIAL_AMOUNT) => {
    const balance = Number(value);
    return Number.isFinite(balance) ? balance : fallback;
  };

  setOnlinePlayerBalance = (balance, { animateIncrease = false, animateDecrease = false } = {}) => {
    const nextBalance = this.getNormalizedBalanceValue(balance);
    const currentBalance = Number(this.state.onlinePlayerBalance);
    const shouldAnimate = Number.isFinite(currentBalance) && (
      (animateIncrease && nextBalance > currentBalance) ||
      (animateDecrease && nextBalance < currentBalance)
    );

    this.confirmedOnlinePlayerBalance = nextBalance;

    if (this.balanceAnimationFrame && window.cancelAnimationFrame) {
      window.cancelAnimationFrame(this.balanceAnimationFrame);
      this.balanceAnimationFrame = null;
    }

    if (
      !shouldAnimate ||
      !window.requestAnimationFrame
    ) {
      this.setState({ onlinePlayerBalance: nextBalance });
      return;
    }

    const startedAt = window.performance?.now ? window.performance.now() : Date.now();
    const difference = nextBalance - currentBalance;

    const tick = (timestamp) => {
      const elapsed = timestamp - startedAt;
      const progress = Math.min(elapsed / ONLINE_BALANCE_ANIMATION_MS, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const displayedBalance = Math.round(currentBalance + (difference * easedProgress));

      this.setState({ onlinePlayerBalance: displayedBalance });

      if (progress < 1) {
        this.balanceAnimationFrame = window.requestAnimationFrame(tick);
      } else {
        this.balanceAnimationFrame = null;
        this.setState({ onlinePlayerBalance: nextBalance });
      }
    };

    this.balanceAnimationFrame = window.requestAnimationFrame(tick);
  };

  playWinCelebrationSound = () => {
    const audio = this.winAudioRef.current;

    if (!audio || this.isMuted) {
      return;
    }

    try {
      audio.pause();
      audio.currentTime = 0;
      audio.volume = 0.78;
      audio.muted = false;

      const playback = audio.play();
      if (playback?.catch) {
        playback.catch(() => {});
      }
    } catch (error) {
      // Browser audio policies may block playback until the first interaction.
    }
  };

  playCongratsWinCelebrationSound = () => {
    const audio = this.congratsWinAudioRef.current;

    if (!audio || this.isMuted) {
      return;
    }

    try {
      audio.pause();
      audio.currentTime = 0;
      audio.volume = 0.82;
      audio.muted = false;

      const playback = audio.play();
      if (playback?.catch) {
        playback.catch(() => {});
      }
    } catch (error) {
      // Browser audio policies may block playback until the first interaction.
    }
  };

  showWinCelebration = (amount, { isProfitableWin = false } = {}) => {
    const winAmount = Number(amount);

    if (!Number.isFinite(winAmount) || winAmount <= 0) {
      return;
    }

    if (this.winCelebrationTimer) {
      clearTimeout(this.winCelebrationTimer);
    }

    this.setState((state) => ({
      winCelebration: {
        amount: winAmount,
        id: (state.winCelebration?.id || 0) + 1,
      },
    }));
    this.playWinCelebrationSound();
    if (isProfitableWin) {
      this.playCongratsWinCelebrationSound();
    }

    this.winCelebrationTimer = setTimeout(() => {
      this.winCelebrationTimer = null;

      if (this.isOnlineWheelMounted) {
        this.setState({ winCelebration: null });
      }
    }, ONLINE_WIN_CELEBRATION_MS);
  };

  isPlayerSessionExpired = (session) => {
    return isPlayerSessionExpired(session);
  };

  applyPlayerSession = (session, { celebrateBalanceIncrease = false } = {}) => {
    const { isNewPlayerSession = false, ...playerSession } = session;

    this.setAxiosAuthorizationHeader(playerSession.tokenHash);
    this.persistPlayerSession(playerSession);

    const bettingShopID = playerSession.shop?.bettingShopId || playerSession.shop?._id || '';
    const agentID = playerSession.agentID
      || playerSession.agentId
      || playerSession.agent?._id
      || playerSession.player?.agentID
      || playerSession.player?.agentId
      || playerSession.player?._id
      || playerSession.raw?.agentID
      || playerSession.raw?.agentId
      || '';
    const gameID = playerSession.game?.gameID
      || playerSession.game?.gameId
      || playerSession.game?._id
      || playerSession.raw?.gameID
      || playerSession.raw?.gameId
      || playerSession.raw?.game?._id
      || '';
    const balance = this.getNormalizedBalanceValue(playerSession.balance);
    const hasConfirmedBalance = this.confirmedOnlinePlayerBalance !== null
      && this.confirmedOnlinePlayerBalance !== undefined;
    const previousConfirmedBalance = hasConfirmedBalance
      ? Number(this.confirmedOnlinePlayerBalance)
      : NaN;
    const hasDisplayedBalance = this.state.onlinePlayerBalance !== null
      && this.state.onlinePlayerBalance !== undefined
      && this.state.onlinePlayerBalance !== '';
    const currentBalance = Number.isFinite(previousConfirmedBalance)
      ? previousConfirmedBalance
      : (hasDisplayedBalance ? Number(this.state.onlinePlayerBalance) : NaN);
    const winAmount = celebrateBalanceIncrease
      && Number.isFinite(currentBalance)
      && balance > currentBalance
      ? balance - currentBalance
      : 0;
    const investedAmount = celebrateBalanceIncrease
      ? Number(this.state.pendingRoundBetAmount) || 0
      : 0;

    this.confirmedOnlinePlayerBalance = balance;

    this.latestOnlineAgentID = agentID || this.latestOnlineAgentID;
    this.latestOnlineGameID = gameID || this.latestOnlineGameID;

    if (isNewPlayerSession) {
      this.lastAutomaticBetSpinNumber = '';
    }

    this.setState({
      playerAuthStatus: 'authenticated',
      playerAuthError: '',
      playerAuthCanRetry: false,
      playerTokenHash: playerSession.tokenHash,
      playerSession,
      onlinePlayer: playerSession.player,
      onlinePlayerShop: playerSession.shop,
      bettingShopID,
      agentID,
      gameID,
      ...(isNewPlayerSession ? {
        betsMap: {},
        betsTotal: 0,
        pendingRoundBetAmount: 0,
        betMessage: '',
        isBetEraseMode: false,
        isSubmittingBet: false,
      } : (celebrateBalanceIncrease ? { pendingRoundBetAmount: 0 } : {})),
    }, () => {
      this.setOnlinePlayerBalance(balance, { animateIncrease: true });

      if (winAmount > 0) {
        this.showWinCelebration(winAmount, {
          isProfitableWin: investedAmount > 0 && winAmount > investedAmount,
        });
      }
    });
  };

  exchangeLaunchTokenForSession = async (launchToken, tokenHash = '') => {
    const initialBalance = this.getInitialBalanceFromUrl();
    const initialMemberId = this.getInitialMemberIdFromUrl();
    const payload = {
      provider: 'sunny-online',
      launchToken,
      gameCode: 'sunny-roulette',
      language: navigator.language || 'en',
      device: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
      returnUrl: new URL(window.location.href).searchParams.get('returnUrl') || undefined,
      ...(initialBalance !== undefined ? { balance: initialBalance } : {}),
      ...(initialMemberId ? { memberId: initialMemberId } : {}),
    };

    const response = await this.postFirstAvailable(PLAYER_SESSION_EXCHANGE_PATHS, payload, {
      headers: getPlayerSessionHeaders({ tokenHash }),
      timeout: ONLINE_AUTH_REQUEST_TIMEOUT_MS,
    });
    const session = this.normalizePlayerSession(response?.data);

    if (!session.tokenHash) {
      throw new Error('Player tokenHash is missing in launch response');
    }

    return {
      ...session,
      launchToken,
      isNewPlayerSession: !tokenHash || session.tokenHash !== tokenHash,
    };
  };

  restorePlayerSession = async (tokenHash, cachedSession = null) => {
    const launchToken = cachedSession?.launchToken || this.getLaunchTokenFromUrl();
    this.setAxiosAuthorizationHeader(tokenHash);

    const response = await this.getFirstAvailable(PLAYER_SESSION_ME_PATHS, {
      headers: this.getPlayerAuthHeaders(tokenHash),
      timeout: ONLINE_AUTH_REQUEST_TIMEOUT_MS,
    });
    const session = this.normalizePlayerSession({
      ...(response?.data || {}),
      tokenHash,
    });

    if (!session.tokenHash) {
      throw new Error('Stored player tokenHash is invalid');
    }

    return {
      ...(cachedSession || {}),
      ...session,
      launchToken: launchToken || session.launchToken || '',
    };
  };

  refreshCachedPlayerSessionInBackground = (cachedSession) => {
    this.restorePlayerSession(cachedSession.tokenHash, cachedSession)
      .then((session) => {
        if (this.isOnlineWheelMounted) {
          this.applyPlayerSession(session);
        }
      })
      .catch(async (error) => {
        if (!this.isOnlineWheelMounted || !isSessionAuthorizationError(error)) {
          return;
        }

        try {
          const session = await this.exchangeLaunchTokenForSession(
            cachedSession.launchToken,
            cachedSession.tokenHash
          );

          if (this.isOnlineWheelMounted) {
            this.applyPlayerSession(session);
          }
        } catch (recoveryError) {
          if (!this.isOnlineWheelMounted || isNetworkRequestError(recoveryError)) {
            return;
          }

          this.clearPersistedPlayerSession();
          clearOnlineGameSessionState();
          this.setState({
            playerAuthStatus: 'failed',
            playerAuthError: this.getErrorMessage(recoveryError, 'Unable to authenticate player session'),
            playerAuthCanRetry: false,
          });
        }
      });
  };

  authenticateOnlinePlayer = async () => {
    const launchToken = this.getLaunchTokenFromUrl();
    const storedSession = this.getStoredPlayerSession();
    const storedTokenHash = storedSession?.tokenHash || '';
    const hasUsableStoredSession = Boolean(storedTokenHash) && !this.isPlayerSessionExpired(storedSession);
    const storedLaunchToken = storedSession?.launchToken || '';
    const canReuseStoredSession = hasUsableStoredSession && storedLaunchToken === launchToken;
    const recoveryTokenHash = storedLaunchToken === launchToken ? storedTokenHash : '';
    let session = null;

    try {
      if (!launchToken) {
        this.clearPersistedPlayerSession();
        clearOnlineGameSessionState();
        throw new Error('Missing launch token');
      }

      if (canReuseStoredSession) {
        session = storedSession;
        this.applyPlayerSession(session);
        this.refreshCachedPlayerSessionInBackground(session);
        return session;
      }

      this.setState({
        playerAuthStatus: 'authenticating',
        playerAuthError: '',
        playerAuthCanRetry: false,
      });

      session = await this.exchangeLaunchTokenForSession(launchToken, recoveryTokenHash);

      if (!session || !this.isOnlineWheelMounted) {
        throw new Error('Missing launch token');
      }

      this.applyPlayerSession(session);
      return session;
    } catch (error) {
      this.restoreAxiosAuthorizationHeader();

      if (!this.isOnlineWheelMounted) {
        return false;
      }

      if (!isNetworkRequestError(error)) {
        this.clearPersistedPlayerSession();
        clearOnlineGameSessionState();
      }

      this.stopOnlineWheelRuntime({ blockFuturePlay: !isNetworkRequestError(error) });
      this.setState({
        playerAuthStatus: 'failed',
        playerAuthError: isNetworkRequestError(error)
          ? 'Connection interrupted. Reconnect and retry.'
          : this.getErrorMessage(error, 'Unable to authenticate player session'),
        playerAuthCanRetry: isNetworkRequestError(error),
      });
      return false;
    }
  };

  refreshActivePlayerSession = async ({
    recoverExpired = true,
    celebrateBalanceIncrease = false,
  } = {}) => {
    const storedSession = this.getStoredPlayerSession();
    const tokenHash = this.state.playerTokenHash || storedSession?.tokenHash || '';

    if (!tokenHash) {
      return false;
    }

    try {
      const session = await this.restorePlayerSession(tokenHash, this.state.playerSession || storedSession);
      this.applyPlayerSession(session, { celebrateBalanceIncrease });
      return session;
    } catch (error) {
      this.restoreAxiosAuthorizationHeader();

      if (isNetworkRequestError(error) || !isSessionAuthorizationError(error)) {
        return this.state.playerSession || storedSession || false;
      }

      this.clearPersistedPlayerSession();

      if (recoverExpired && this.getLaunchTokenFromUrl()) {
        return await this.authenticateOnlinePlayer();
      }

      this.setState({
        playerAuthStatus: 'failed',
        playerAuthError: this.getErrorMessage(error, 'Unable to refresh player session'),
        playerAuthCanRetry: false,
      });
      return false;
    }
  };

  touchPlayerSession = () => {
    this.refreshActivePlayerSession({ recoverExpired: true });
  };

  schedulePostSpinBalanceRefresh = (delay = ONLINE_BALANCE_REFRESH_DELAY_MS) => {
    if (!this.isPlayerAuthenticated() || this.state.playerSession?.isDemo) {
      return;
    }

    if (this.balanceRefreshTimer) {
      clearTimeout(this.balanceRefreshTimer);
    }

    this.balanceRefreshTimer = setTimeout(() => {
      this.balanceRefreshTimer = null;
      this.refreshActivePlayerSession({
        recoverExpired: true,
        celebrateBalanceIncrease: true,
      });
    }, delay);
  };

  getPlayerAuthHeaders = (tokenHash = this.state.playerTokenHash) => (
    getPlayerSessionHeaders({ tokenHash })
  );

  getStoredPlayerHistory = () => {
    try {
      const storedHistory = localStorage.getItem(ONLINE_PLAYER_HISTORY_KEY);
      return storedHistory ? JSON.parse(storedHistory) : [];
    } catch (error) {
      return [];
    }
  };

  setStoredPlayerHistory = (history) => {
    localStorage.setItem(ONLINE_PLAYER_HISTORY_KEY, JSON.stringify(history.slice(0, 50)));
  };

  syncOnlineGameMeta = (data = {}) => {
    // console.log('game data', data);
    const previousGameID = this.latestOnlineGameID || this.state.gameID;
    const nextGameID = data.gameID
      || data.gameId
      || data.game?._id
      || data.game?.gameID
      || data.game?.gameId
      || '';
    const nextGameSpinNumber = data.gameSpinNumber
      || data.spinNumber
      || data.spin
      || '';
    const nextAgentID = data.agentID || data.agentId || data.agent?._id || '';
    const timerSeconds = Number(data.timer);
    const updates = {};

    if (Number.isFinite(timerSeconds)) {
      const bettingTimeRemaining = getOnlineBettingTimeRemaining(timerSeconds);
      const isAutoBetCutoffActive = timerSeconds >= ONLINE_AUTO_BET_SUBMIT_START
        && timerSeconds < ONLINE_ROUND_SECONDS;
      const isSpinEntryLocked = timerSeconds >= ONLINE_SPIN_ENTRY_LOCK_START && timerSeconds < ONLINE_ROUND_SECONDS;
      const isAutomaticBetWindow = timerSeconds >= ONLINE_AUTO_BET_SUBMIT_START
        && timerSeconds < ONLINE_SPIN_ENTRY_LOCK_START;

      if (timerSeconds <= 1 && this.isOnlineWheelSpinAnimating) {
        this.isOnlineWheelSpinAnimating = false;
        this.scheduleOnlineWheelIdleSpin();
      }

      updates.timer = bettingTimeRemaining;
      // The bar targets the end of this second so its 1s CSS transition reaches
      // zero exactly when automatic bet submission starts.
      updates.progressPerc = getOnlineProgressTimeRemaining(bettingTimeRemaining);

      if (isAutoBetCutoffActive !== this.state.isAutoBetCutoffActive) {
        updates.isAutoBetCutoffActive = isAutoBetCutoffActive;
      }

      if (isSpinEntryLocked !== this.state.isSpinEntryLocked) {
        updates.isSpinEntryLocked = isSpinEntryLocked;
      }

      if (!this.state.isLoaded && !isSpinEntryLocked) {
        updates.isLoaded = true;
      }

      if (isAutoBetCutoffActive && this.state.isBettingTableExpanded) {
        updates.isBettingTableExpanded = false;
        updates.isBettingTableClosing = false;
      }

      if (isAutomaticBetWindow) {
        this.submitAutomaticBet(nextGameSpinNumber || this.latestOnlineGameSpinNumber || this.state.currentSpinId);
      }
    }

    if (nextGameID) {
      this.latestOnlineGameID = nextGameID;

      if (nextGameID !== this.state.gameID) {
        updates.gameID = nextGameID;
      }

      if (
        previousGameID
        && String(nextGameID) !== String(previousGameID)
        && Number.isFinite(timerSeconds)
        && timerSeconds <= 1
      ) {
        this.schedulePostSpinBalanceRefresh(ONLINE_POST_ROUND_BALANCE_REFRESH_DELAY_MS);
      }
    }

    if (nextGameSpinNumber) {
      this.latestOnlineGameSpinNumber = nextGameSpinNumber;

      if (nextGameSpinNumber !== this.state.gameSpinNumber) {
        updates.gameSpinNumber = nextGameSpinNumber;
      }
    }

    if (nextAgentID) {
      this.latestOnlineAgentID = nextAgentID;

      if (nextAgentID !== this.state.agentID) {
        updates.agentID = nextAgentID;
      }
    }

    if (Object.keys(updates).length) {
      this.setState(updates);
    }
  };

  showBetNotification = (message) => {
    if (this.betNotificationTimer) {
      clearTimeout(this.betNotificationTimer);
    }

    this.setState({ betNotification: message });
    this.betNotificationTimer = setTimeout(() => {
      this.betNotificationTimer = null;
      this.setState({ betNotification: '' });
    }, 3000);
  };

  calculateDemoPayouts = (bets, winningNumber) => {
    const resultNumber = String(winningNumber);

    return Object.entries(bets || {}).reduce(
      (summary, [betKey, value]) => {
        const stake = Number(value) || 0;
        const bet = betmap[betKey];
        const isWinningBet = bet?.numbers?.map(String).includes(resultNumber);
        const payout = isWinningBet ? stake * ((Number(bet.payout) || 0) + 1) : 0;

        return {
          payoutAmount: summary.payoutAmount + payout,
          payouts: {
            ...summary.payouts,
            [betKey]: payout,
          },
        };
      },
      { payoutAmount: 0, payouts: {} }
    );
  };

  appendDemoHistoryEntry = (payload, nextBalance) => {
    const currentHistory = this.getStoredPlayerHistory();
    const entry = {
      id: payload.clientRequestId,
      ticketId: `DEMO-${String(Date.now()).slice(-6)}`,
      playerId: this.state.onlinePlayer?._id || 'demo-online-player',
      playerName: this.state.onlinePlayer?.displayName || this.state.onlinePlayer?.username || 'Demo Player',
      spinNumber: payload.spinNumber || this.state.currentSpinId || '-',
      bets: payload.bets,
      betAmount: payload.betAmount,
      payoutAmount: 0,
      payouts: {},
      resultNumber: null,
      outcome: 'PENDING',
      status: 'ACCEPTED',
      balanceAfter: nextBalance,
      createdAt: new Date().toISOString(),
      isDemo: true,
    };

    this.setStoredPlayerHistory([entry, ...currentHistory]);
  };

  settleDemoHistory = (winningNumber) => {
    const currentHistory = this.getStoredPlayerHistory();
    const spinNumber = String(this.state.currentSpinId || '');
    let totalPayout = 0;
    let totalBetAmount = 0;
    let hasSettled = false;

    const settledHistory = currentHistory.map((item) => {
      const itemStatus = String(item.status || item.outcome || '').toUpperCase();
      const isPending = ['ACCEPTED', 'PENDING'].includes(itemStatus) && item.resultNumber === null;
      const isSameSpin = !spinNumber || String(item.spinNumber) === spinNumber;

      if (!isPending || !isSameSpin) {
        return item;
      }

      const settlement = this.calculateDemoPayouts(item.bets, winningNumber);
      totalPayout += settlement.payoutAmount;
      totalBetAmount += Number(item.betAmount) || this.getBetsTotal(item.bets || {});
      hasSettled = true;

      return {
        ...item,
        resultNumber: winningNumber,
        payoutAmount: settlement.payoutAmount,
        payouts: settlement.payouts,
        outcome: settlement.payoutAmount > 0 ? 'WIN' : 'LOSS',
        status: 'SETTLED',
        settledAt: new Date().toISOString(),
      };
    });

    if (!hasSettled) {
      return;
    }

    this.setStoredPlayerHistory(settledHistory);
    this.setState({ pendingRoundBetAmount: 0 });

    if (totalPayout > 0) {
      const currentBalance = Number(this.state.onlinePlayerBalance) || 0;
      this.setOnlinePlayerBalance(currentBalance + totalPayout, { animateIncrease: true });
      this.showWinCelebration(totalPayout, {
        isProfitableWin: totalPayout > totalBetAmount,
      });
    }
  };

  spinWheel = (winningNumber) => {
    if (this.isOnlineWheelSpinAnimating) {
      return;
    }

    this.isOnlineWheelSpinAnimating = true;
    this.clearOnlineWheelIdleRestart();
    this.stopOnlineWheelIdleSpin();
    this.stopOnlineWheelPreSpin();
    this.setOnlineWheelIdleBallsHidden(false);

    if (typeof this.baseSpinWheel === 'function') {
      this.baseSpinWheel(winningNumber);
    }

    if (this.state.playerSession?.isDemo) {
      this.settleDemoHistory(winningNumber);
    } else {
      this.schedulePostSpinBalanceRefresh();
    }
  };

  getStraightBetKey = (number) => {
    return number === 0 ? 'SINGLE37' : `SINGLE${number}`;
  };

  getBetColor = (number) => {
    const match = options.find(item => item.number === String(number));
    return match ? match.color : 'black';
  };

  getSelectedBetsCount = () => {
    return Object.values(this.state.betsMap).filter(Boolean).length;
  };

  isPlayerAuthenticated = () => {
    return this.state.playerAuthStatus === 'authenticated' && Boolean(this.state.playerTokenHash);
  };

  getBetsTotal = (betsMap) => {
    return Object.values(betsMap).reduce((sum, value) => sum + (value || 0), 0);
  };

  getRepeatBetPlayerKey = (session = this.state.playerSession) => {
    const player = session?.player || this.state.onlinePlayer;
    const playerKey = session?.memberId
      || player?.memberId
      || player?._id
      || session?.playerSessionId
      || session?.tokenHash
      || this.state.playerTokenHash
      || '';

    return String(playerKey).trim();
  };

  normalizeRepeatBets = (bets = {}) => {
    if (!bets || typeof bets !== 'object' || Array.isArray(bets)) {
      return {};
    }

    return Object.entries(bets).reduce((normalizedBets, [betKey, value]) => {
      const amount = Number(value);

      if (betmap[betKey] && Number.isFinite(amount) && amount > 0) {
        normalizedBets[betKey] = amount;
      }

      return normalizedBets;
    }, {});
  };

  getRepeatBetRecords = () => {
    if (typeof window === 'undefined' || !window.localStorage) {
      return [];
    }

    try {
      const storedRecords = JSON.parse(window.localStorage.getItem(ONLINE_REPEAT_BETS_STORAGE_KEY) || '[]');
      return Array.isArray(storedRecords) ? storedRecords : [];
    } catch (error) {
      return [];
    }
  };

  getLastAcceptedBets = () => {
    const playerKey = this.getRepeatBetPlayerKey();

    if (!playerKey) {
      return {};
    }

    const record = this.getRepeatBetRecords().find(item => item?.playerKey === playerKey);
    return this.normalizeRepeatBets(record?.bets);
  };

  persistLastAcceptedBets = (bets, session = this.state.playerSession) => {
    const playerKey = this.getRepeatBetPlayerKey(session);
    const normalizedBets = this.normalizeRepeatBets(bets);

    if (
      !playerKey
      || !Object.keys(normalizedBets).length
      || typeof window === 'undefined'
      || !window.localStorage
    ) {
      return;
    }

    try {
      const nextRecords = [
        {
          playerKey,
          bets: normalizedBets,
          savedAt: Date.now(),
        },
        ...this.getRepeatBetRecords().filter(item => item?.playerKey !== playerKey),
      ].slice(0, ONLINE_REPEAT_BETS_STORAGE_LIMIT);

      window.localStorage.setItem(ONLINE_REPEAT_BETS_STORAGE_KEY, JSON.stringify(nextRecords));
    } catch (error) {
      // Repeating a bet is optional when browser storage is unavailable.
    }
  };

  getWalletBalance = (state = this.state) => {
    const hasStoredBalance = state.onlinePlayerBalance !== null
      && state.onlinePlayerBalance !== undefined
      && state.onlinePlayerBalance !== '';
    const storedBalance = Number(state.onlinePlayerBalance);
    const walletBalance = hasStoredBalance && Number.isFinite(storedBalance)
      ? storedBalance
      : ONLINE_BALANCE_INITIAL_AMOUNT;

    return Math.max(walletBalance, 0);
  };

  getDisplayedWalletBalance = () => this.getWalletBalance();

  getOnlineBettingShopID = (session = this.state.playerSession) => (
    session?.shop?.bettingShopId
    || session?.shop?._id
    || session?.raw?.bettingShopID
    || session?.raw?.bettingShopId
    || this.state.bettingShopID
    || this.state.onlinePlayerShop?.bettingShopId
    || this.state.onlinePlayerShop?._id
    || localStorage.getItem('sun_bettingShopId')
    || ''
  );

  getOnlineAgentID = (session = this.state.playerSession) => (
    session?.agentID
    || session?.agentId
    || session?.agent?._id
    || session?.player?.agentID
    || session?.player?.agentId
    || session?.player?._id
    || session?.raw?.agentID
    || session?.raw?.agentId
    || this.latestOnlineAgentID
    || this.state.agentID
    || this.state.onlinePlayer?.agentID
    || this.state.onlinePlayer?.agentId
    || this.state.onlinePlayer?._id
    || localStorage.getItem('sun_userId')
    || ''
  );

  getOnlineGameID = (session = this.state.playerSession) => (
    this.latestOnlineGameID
    || this.state.gameID
    || session?.game?.gameID
    || session?.game?.gameId
    || session?.game?._id
    || session?.raw?.gameID
    || session?.raw?.gameId
    || session?.raw?.game?._id
    || ''
  );

  isBettingLocked = () => this.state.isAutoBetCutoffActive || this.state.isSpinEntryLocked;

  getMaxBetForKey = (betKey) => (
    OUTSIDE_BET_KEYS.has(betKey) ? MAX_OUTSIDE_BET_AMOUNT : MAX_INSIDE_BET_AMOUNT
  );

  formatLimitAmount = (amount) => `$${amount.toLocaleString('en-US')}`;

  buildPlaceBetPayload = (
    bets,
    session = this.state.playerSession,
    spinNumberOverride = '',
    betAmount = this.state.betsTotal
  ) => {
    const spinNumber = spinNumberOverride
      || this.latestOnlineGameSpinNumber
      || this.state.gameSpinNumber
      || this.state.currentSpinId;

    return {
      clientRequestId: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      bettingShopID: this.getOnlineBettingShopID(session),
      gameID: this.getOnlineGameID(session),
      agentID: this.getOnlineAgentID(session),
      tokenHash: session?.tokenHash || this.state.playerTokenHash,
      spinNumber,
      spin: spinNumber,
      bets,
      betAmount,
    };
  };

  forceWheelView = () => {
    if (this.bettingTableAnimationTimer) {
      clearTimeout(this.bettingTableAnimationTimer);
      this.bettingTableAnimationTimer = null;
    }

    this.setState({
      isBettingTableExpanded: false,
      isBettingTableClosing: false,
    });
  };

  openBettingTable = () => {
    this.touchPlayerSession();

    if (this.isBettingLocked()) {
      this.setState({ betMessage: 'Bets are closed' });
      this.forceWheelView();
      return;
    }

    if (this.bettingTableAnimationTimer) {
      clearTimeout(this.bettingTableAnimationTimer);
      this.bettingTableAnimationTimer = null;
    }

    this.setState({
      isBettingTableExpanded: true,
      isBettingTableClosing: false,
    });
  };

  closeBettingTable = () => {
    this.touchPlayerSession();

    if (this.bettingTableAnimationTimer) {
      clearTimeout(this.bettingTableAnimationTimer);
    }

    this.setState({ isBettingTableClosing: true });
    this.bettingTableAnimationTimer = setTimeout(() => {
      this.bettingTableAnimationTimer = null;
      this.setState({
        isBettingTableExpanded: false,
        isBettingTableClosing: false,
      });
    }, BETTING_TABLE_ANIMATION_MS);
  };

  toggleBettingTableView = () => {
    this.touchPlayerSession();
    this.setState(prevState => ({
      isRacetrackView: !prevState.isRacetrackView,
      hoveredCrossBetKey: '',
      betMessage: '',
    }));
  };

  placeBet = (betKey) => {
    this.touchPlayerSession();

    if (!this.isPlayerAuthenticated()) {
      this.setState({ betMessage: 'Player session required' });
      return;
    }

    if (!this.state.isBettingTableExpanded && !this.state.isDesktopSplitLayout) {
      this.setState({ betMessage: 'Expand betting table to place bets' });
      return;
    }

    if (this.isBettingLocked()) {
      this.setState({ betMessage: 'Bets are closed' });
      this.forceWheelView();
      return;
    }

    const bet = betmap[betKey];

    if (!bet) {
      return;
    }

    if (this.state.isBetEraseMode) {
      this.setState((prevState) => {
        if (!prevState.betsMap[betKey]) {
          return { betMessage: '' };
        }

        const betsMap = { ...prevState.betsMap };
        delete betsMap[betKey];

        return {
          betsMap,
          betsTotal: this.getBetsTotal(betsMap),
          betMessage: '',
        };
      });
      return;
    }

    const denomination = this.state.betDenomination;

    if (!denomination) {
      return;
    }

    let didPlaceBet = false;

    this.setState((prevState) => {
      const betsMap = { ...prevState.betsMap };
      const currentBetAmount = Number(betsMap[betKey]) || 0;
      const nextBetAmount = currentBetAmount + denomination;
      const currentTotal = Number(prevState.betsTotal) || this.getBetsTotal(betsMap);
      const nextTotal = currentTotal + denomination;
      const maxBetForKey = this.getMaxBetForKey(betKey);
      const walletBalance = this.getWalletBalance(prevState);

      if (nextTotal > walletBalance) {
        return {
          betMessage: `Available balance is ${this.formatLimitAmount(walletBalance)}`,
        };
      }

      if (nextTotal > MAX_TOTAL_BET_AMOUNT) {
        return {
          betMessage: `Maximum total bet is ${this.formatLimitAmount(MAX_TOTAL_BET_AMOUNT)}`,
        };
      }

      if (nextBetAmount > maxBetForKey) {
        return {
          betMessage: `Maximum for this bet is ${this.formatLimitAmount(maxBetForKey)}`,
        };
      }

      betsMap[betKey] = nextBetAmount;
      didPlaceBet = true;

      return {
        betsMap,
        betsTotal: this.getBetsTotal(betsMap),
        betMessage: '',
      };
    }, () => {
      if (didPlaceBet) {
        this.playChipPlacementSound();
      }
    });
  };

  clearBets = () => {
    this.touchPlayerSession();

    this.setState({
      betsMap: {},
      betsTotal: 0,
      betMessage: '',
      isBetEraseMode: false,
    });
  };

  repeatLastBet = () => {
    this.touchPlayerSession();

    if (!this.isPlayerAuthenticated()) {
      this.setState({ betMessage: 'Player session required' });
      return;
    }

    if (this.isBettingLocked()) {
      this.setState({ betMessage: 'Bets are closed' });
      this.forceWheelView();
      return;
    }

    const betsMap = this.getLastAcceptedBets();
    const betsTotal = this.getBetsTotal(betsMap);

    if (!betsTotal) {
      this.showBetNotification('No previous bet to repeat');
      return;
    }

    if (betsTotal > this.getWalletBalance()) {
      this.showBetNotification('Not enough funds to repeat a bet');
      return;
    }

    if (betsTotal > MAX_TOTAL_BET_AMOUNT) {
      this.setState({ betMessage: `Maximum total bet is ${this.formatLimitAmount(MAX_TOTAL_BET_AMOUNT)}` });
      return;
    }

    const overLimitBet = Object.entries(betsMap).find(([betKey, amount]) => (
      amount > this.getMaxBetForKey(betKey)
    ));

    if (overLimitBet) {
      this.setState({
        betMessage: `Maximum for this bet is ${this.formatLimitAmount(this.getMaxBetForKey(overLimitBet[0]))}`,
      });
      return;
    }

    this.setState({
      betsMap,
      betsTotal,
      betMessage: '',
      isBetEraseMode: false,
    }, this.playChipPlacementSound);
  };

  selectBetDenomination = (value) => {
    this.touchPlayerSession();
    this.setState({ betDenomination: value, isBetEraseMode: false });
  };

  enableBetEraseMode = () => {
    this.touchPlayerSession();
    this.setState({ isBetEraseMode: true });
  };

  submitAutomaticBet = (spinNumber) => {
    const spinKey = String(spinNumber || '').trim();

    if (
      !spinKey
      || this.lastAutomaticBetSpinNumber === spinKey
      || !this.state.betsTotal
      || !this.isPlayerAuthenticated()
      || this.isBetSubmissionInFlight
    ) {
      return;
    }

    this.lastAutomaticBetSpinNumber = spinKey;
    this.submitBet({ automatic: true, spinNumber: spinKey });
  };

  submitBet = async ({ automatic = false, spinNumber = '' } = {}) => {
    if (this.isBetSubmissionInFlight || this.state.isSubmittingBet || !this.state.betsTotal) {
      return;
    }

    if (!automatic && !this.state.isBettingTableExpanded && !this.state.isDesktopSplitLayout) {
      this.setState({ betMessage: 'Expand betting table to place bets' });
      return;
    }

    if (!this.isPlayerAuthenticated()) {
      this.setState({ betMessage: 'Player session required' });
      return;
    }

    if (!automatic && this.isBettingLocked()) {
      this.setState({ betMessage: 'Bets are closed' });
      this.forceWheelView();
      return;
    }

    const betAmount = Number(this.state.betsTotal) || 0;
    const walletBalance = this.getWalletBalance();

    if (betAmount > walletBalance) {
      this.setState({ betMessage: `Available balance is ${this.formatLimitAmount(walletBalance)}` });
      return;
    }

    if (betAmount > MAX_TOTAL_BET_AMOUNT) {
      this.setState({ betMessage: `Maximum total bet is ${this.formatLimitAmount(MAX_TOTAL_BET_AMOUNT)}` });
      return;
    }

    const overLimitBet = Object.entries(this.state.betsMap).find(([betKey, amount]) => {
      return (Number(amount) || 0) > this.getMaxBetForKey(betKey);
    });

    if (overLimitBet) {
      this.setState({ betMessage: `Maximum for this bet is ${this.formatLimitAmount(this.getMaxBetForKey(overLimitBet[0]))}` });
      return;
    }

    const bets = Object.fromEntries(
      Object.entries(this.state.betsMap).filter(([, value]) => value && !isNaN(value))
    );

    this.isBetSubmissionInFlight = true;
    this.setState({ isSubmittingBet: true, betMessage: '' });

    let payload = null;

    try {
      const activeSession = await this.refreshActivePlayerSession({ recoverExpired: true });

      if (!activeSession) {
        throw new Error('Player session required');
      }

      if (activeSession.isNewPlayerSession) {
        throw new Error('New player session started. Bets were cleared.');
      }

      const activeSessionBalance = activeSession === true ? NaN : Number(activeSession.balance);
      const latestWalletBalance = Number.isFinite(activeSessionBalance)
        ? Math.max(activeSessionBalance, 0)
        : this.getWalletBalance();

      if (betAmount > latestWalletBalance) {
        throw new Error(`Available balance is ${this.formatLimitAmount(latestWalletBalance)}`);
      }

      payload = this.buildPlaceBetPayload(
        bets,
        activeSession === true ? this.state.playerSession : activeSession,
        spinNumber,
        betAmount
      );

      const response = await this.postFirstAvailable(PLAYER_BETS_PATHS, payload, {
        headers: this.getPlayerAuthHeaders(),
      });

      if (response?.data?.success !== true) {
        throw new Error(response?.data?.error || 'Unable to submit bet');
      }

      this.persistLastAcceptedBets(
        bets,
        activeSession === true ? this.state.playerSession : activeSession
      );

      const currentBalance = Number(this.state.onlinePlayerBalance) || 0;
      const responseBalance = response?.data?.balance ?? response?.data?.playerBalance;
      const balance = responseBalance !== undefined && responseBalance !== null
        ? this.getNormalizedBalanceValue(responseBalance, this.state.onlinePlayerBalance)
        : Math.max(currentBalance - payload.betAmount, 0);
      const updatedPlayerSession = this.state.playerSession
        ? { ...this.state.playerSession, balance }
        : this.state.playerSession;
      const updatedOnlinePlayer = this.state.onlinePlayer
        ? { ...this.state.onlinePlayer, balance }
        : this.state.onlinePlayer;

      if (this.state.playerSession?.isDemo) {
        this.appendDemoHistoryEntry(payload, balance);
      }

      this.setState({
        betsMap: {},
        betsTotal: 0,
        pendingRoundBetAmount: payload.betAmount,
        isSubmittingBet: false,
        playerSession: updatedPlayerSession,
        onlinePlayer: updatedOnlinePlayer,
        betMessage: '',
      }, () => {
        this.setOnlinePlayerBalance(balance, { animateDecrease: true });
      });
      this.showBetNotification(ONLINE_BET_SUCCESS_MESSAGE);
    } catch (error) {
      this.setState({
        isSubmittingBet: false,
        betMessage: this.getErrorMessage(error, 'Unable to submit bet'),
      });
    } finally {
      this.isBetSubmissionInFlight = false;
    }
  };

  renderBetAmount = (betKey) => {
    const amount = this.state.betsMap[betKey];
    return amount ? <span className="online-bet-chip">{amount}</span> : null;
  };

  renderNumberButton = (number) => {
    const betKey = this.getStraightBetKey(number);
    const color = this.getBetColor(number);
    const hoveredCrossBet = betmap[this.state.hoveredCrossBetKey];
    const isCrossBetNumberHighlighted = hoveredCrossBet?.numbers
      ?.map(value => String(value))
      .includes(String(number));

    return (
      <button
        type="button"
        className={`online-number-cell online-number-cell--${color} ${isCrossBetNumberHighlighted ? 'online-number-cell--cross-highlight' : ''} ${this.state.isBetEraseMode && this.state.betsMap[betKey] ? 'online-bet-target--erase-ready' : ''}`}
        key={number}
        onClick={() => this.placeBet(betKey)}
      >
        <span>{number}</span>
        {this.renderBetAmount(betKey)}
      </button>
    );
  };

  renderOutsideButton = ({ key, label }) => (
    <button
      type="button"
      className={`online-outside-bet online-outside-bet--${key.toLowerCase()} ${this.state.isBetEraseMode && this.state.betsMap[key] ? 'online-bet-target--erase-ready' : ''}`}
      key={key}
      onClick={() => this.placeBet(key)}
    >
      <span>{label}</span>
      {this.renderBetAmount(key)}
    </button>
  );

  renderRacetrackNumberButton = (number) => {
    const betKey = this.getStraightBetKey(number);
    const color = this.getBetColor(number);

    return (
      <button
        type="button"
        className={`online-number-cell online-racetrack-number online-number-cell--${color} ${this.state.isBetEraseMode && this.state.betsMap[betKey] ? 'online-bet-target--erase-ready' : ''}`}
        key={number}
        onClick={() => this.placeBet(betKey)}
        aria-label={`Bet on ${number}`}
      >
        <span>{number}</span>
        {this.renderBetAmount(betKey)}
      </button>
    );
  };

  renderRacetrackSpecialButton = ({ key, label, clipPath, labelTop }) => {
    const className = `online-outside-bet online-outside-bet--${key.toLowerCase()} ${this.state.isBetEraseMode && this.state.betsMap[key] ? 'online-bet-target--erase-ready' : ''}`;
    const style = {
      clipPath,
      '--online-racetrack-label-top': `${labelTop}%`,
    };

    if (key === 'ZEROSPIEL' || key === 'TIERS') {
      return (
        <div className={`${className} online-racetrack-special-visual`} key={key} style={style} aria-hidden="true">
          <span>{label}</span>
        </div>
      );
    }

    return (
      <button
        type="button"
        className={className}
        key={key}
        onClick={() => this.placeBet(key)}
        style={style}
      >
        <span>{label}</span>
      </button>
    );
  };

  renderRacetrackArcCap = (numbers, position, isHorizontal = false) => {
    const borders = ONLINE_RACETRACK_ARC_BORDERS[position];

    return (
      <svg
        className={`online-racetrack-cap online-racetrack-cap--${position}`}
        viewBox={`0 0 ${ONLINE_RACETRACK_ARC_WIDTH} ${ONLINE_RACETRACK_ARC_HEIGHT}`}
        preserveAspectRatio="none"
        role="group"
        aria-label={`Racetrack ${position} numbers`}
      >
        <defs aria-hidden="true">
          <linearGradient id={`online-racetrack-red-${position}`} x1="0%" y1="0%" x2="14%" y2="100%">
            <stop offset="0%" stopColor="#ff6870"></stop>
            <stop offset="24%" stopColor="#ff3d49"></stop>
            <stop offset="58%" stopColor="#df1225"></stop>
            <stop offset="100%" stopColor="#78040e"></stop>
          </linearGradient>
          <linearGradient id={`online-racetrack-black-${position}`} x1="0%" y1="0%" x2="14%" y2="100%">
            <stop offset="0%" stopColor="#4b554f"></stop>
            <stop offset="28%" stopColor="#202722"></stop>
            <stop offset="60%" stopColor="#090d0a"></stop>
            <stop offset="100%" stopColor="#000000"></stop>
          </linearGradient>
          <linearGradient id={`online-racetrack-green-${position}`} x1="0%" y1="0%" x2="14%" y2="100%">
            <stop offset="0%" stopColor="#48e989"></stop>
            <stop offset="25%" stopColor="#19c661"></stop>
            <stop offset="58%" stopColor="#078c43"></stop>
            <stop offset="100%" stopColor="#034c24"></stop>
          </linearGradient>
          <linearGradient id={`online-racetrack-gloss-${position}`} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.46"></stop>
            <stop offset="34%" stopColor="#fff7d2" stopOpacity="0.14"></stop>
            <stop offset="52%" stopColor="#ffffff" stopOpacity="0"></stop>
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0"></stop>
          </linearGradient>
        </defs>
        <path
          className={`online-racetrack-cap-special-visual online-racetrack-cap-special-visual--${position}`}
          d={ONLINE_RACETRACK_CAP_SPECIAL_PATHS[position]}
          aria-hidden="true"
        ></path>
        {numbers.map((number, index) => {
          const betKey = this.getStraightBetKey(number);
          const color = this.getBetColor(number);
          const amount = this.state.betsMap[betKey];
          const segment = ONLINE_RACETRACK_ARC_SEGMENTS[position][index];

          return (
            <g
              className={`online-racetrack-number online-racetrack-arc-bet online-racetrack-arc-bet--${color} ${this.state.isBetEraseMode && amount ? 'online-bet-target--erase-ready' : ''}`}
              key={number}
              role="button"
              tabIndex="0"
              aria-label={`Bet on ${number}`}
              onClick={() => this.placeBet(betKey)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  this.placeBet(betKey);
                }
              }}
            >
              <path className="online-racetrack-arc-bet__shape" d={segment.path}></path>
              <path
                className="online-racetrack-arc-bet__gloss"
                d={segment.path}
                fill={`url(#online-racetrack-gloss-${position})`}
                aria-hidden="true"
              ></path>
              <text
                className="online-racetrack-arc-bet__number"
                x={segment.label.x}
                y={segment.label.y}
                textAnchor="middle"
                dy="0.35em"
                transform={isHorizontal ? `rotate(90 ${segment.label.x} ${segment.label.y})` : undefined}
              >
                {number}
              </text>
              {amount ? (
                <g
                  className="online-racetrack-arc-chip"
                  transform={isHorizontal ? `rotate(90 ${segment.chip.x} ${segment.chip.y})` : undefined}
                >
                  <ellipse
                    cx={segment.chip.x}
                    cy={segment.chip.y}
                    rx={isHorizontal ? 27 : 19}
                    ry={isHorizontal ? 29 : 21}
                  ></ellipse>
                  <text
                    x={segment.chip.x}
                    y={segment.chip.y}
                    textAnchor="middle"
                    dy="0.35em"
                  >
                    {amount}
                  </text>
                </g>
              ) : null}
            </g>
          );
        })}
        <g className="online-racetrack-cap-borders" aria-hidden="true">
          <path d={borders.outerPath}></path>
          <path d={borders.innerPath}></path>
          {borders.dividers.map((divider, index) => (
            <path d={divider} key={`${position}-divider-${index}`}></path>
          ))}
        </g>
      </svg>
    );
  };

  renderRacetrackMergedSpecialTargets = (isHorizontal = false) => (
    <svg
      className="online-racetrack-merged-specials"
      viewBox={`0 0 ${ONLINE_RACETRACK_ARC_WIDTH} ${ONLINE_RACETRACK_BOARD_HEIGHT}`}
      preserveAspectRatio="none"
      aria-label="Merged racetrack special bets"
    >
      <defs aria-hidden="true">
        <linearGradient id="online-racetrack-zero-surface" gradientUnits="userSpaceOnUse" x1="52" y1="84" x2="208" y2="158">
          <stop offset="0%" stopColor="#35b96c"></stop>
          <stop offset="26%" stopColor="#168b48"></stop>
          <stop offset="62%" stopColor="#08602f"></stop>
          <stop offset="100%" stopColor="#023619"></stop>
        </linearGradient>
        <linearGradient id="online-racetrack-tiers-surface" gradientUnits="userSpaceOnUse" x1="52" y1="478" x2="208" y2="590">
          <stop offset="0%" stopColor="#116d3a"></stop>
          <stop offset="30%" stopColor="#0a542c"></stop>
          <stop offset="68%" stopColor="#053e20"></stop>
          <stop offset="100%" stopColor="#011e0e"></stop>
        </linearGradient>
      </defs>
      {ONLINE_RACETRACK_MERGED_SPECIALS.map(({ key, label, path }) => {
        const specialBet = ONLINE_RACETRACK_SPECIAL_BETS.find(bet => bet.key === key);
        const labelY = ONLINE_RACETRACK_BOARD_CAP_HEIGHT
          + ((specialBet.labelTop / 100) * ONLINE_RACETRACK_BOARD_BODY_HEIGHT);

        return (
          <g
            className={`online-racetrack-merged-special online-racetrack-merged-special--${key.toLowerCase()} ${this.state.isBetEraseMode && this.state.betsMap[key] ? 'online-bet-target--erase-ready' : ''}`}
            key={key}
            role="button"
            tabIndex="0"
            aria-label={label}
            onClick={() => this.placeBet(key)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.placeBet(key);
              }
            }}
          >
            <path className="online-racetrack-merged-special__shape" d={path}></path>
            <text
              className="online-racetrack-merged-special__label"
              x={ONLINE_RACETRACK_ARC_CENTER_X}
              y={labelY}
              textAnchor="middle"
              dy="0.35em"
              transform={isHorizontal ? `rotate(90 ${ONLINE_RACETRACK_ARC_CENTER_X} ${labelY})` : undefined}
              aria-hidden="true"
            >
              {label}
            </text>
          </g>
        );
      })}
    </svg>
  );

  renderRacetrackSpecialChips = () => (
    <div className="online-racetrack-special-chip-layer" aria-hidden="true">
      {ONLINE_RACETRACK_SPECIAL_CHIP_POSITIONS.map(({ key, top }) => {
        const amount = this.state.betsMap[key];

        return amount ? (
          <span
            className="online-bet-chip online-racetrack-special-chip"
            key={key}
            style={{ top: `${top}%` }}
          >
            {amount}
          </span>
        ) : null;
      })}
    </div>
  );

  renderRacetrackBoard = ({ className = '', isHorizontal = false } = {}) => (
    <div
      className={`online-racetrack-board ${className}`.trim()}
      role="group"
      aria-label={isHorizontal ? 'Horizontal racetrack betting table' : 'Racetrack betting table'}
    >
      {this.renderRacetrackArcCap(ONLINE_RACETRACK_TOP_NUMBERS, 'top', isHorizontal)}

      <div className="online-racetrack-body">
        <div className="online-racetrack-rail online-racetrack-rail--left" role="group" aria-label="Racetrack left numbers">
          {ONLINE_RACETRACK_LEFT_NUMBERS.map(this.renderRacetrackNumberButton)}
        </div>

        <div className="online-racetrack-specials" role="group" aria-label="Racetrack special bets">
          {ONLINE_RACETRACK_SPECIAL_BETS.map(this.renderRacetrackSpecialButton)}
          <svg
            className="online-racetrack-special-dividers"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            {ONLINE_RACETRACK_SPECIAL_BOUNDARIES.slice(1, -1).map((boundary, index) => (
              <line
                key={`racetrack-special-divider-${index}`}
                x1="0"
                y1={boundary.left}
                x2="100"
                y2={boundary.right}
              ></line>
            ))}
          </svg>
        </div>

        <div className="online-racetrack-rail online-racetrack-rail--right" role="group" aria-label="Racetrack right numbers">
          {ONLINE_RACETRACK_RIGHT_NUMBERS.map(this.renderRacetrackNumberButton)}
        </div>
      </div>

      {this.renderRacetrackArcCap(ONLINE_RACETRACK_BOTTOM_NUMBERS, 'bottom', isHorizontal)}
      {this.renderRacetrackMergedSpecialTargets(isHorizontal)}
      {this.renderRacetrackSpecialChips()}
    </div>
  );

  renderRacetrackBettingTable = () => (
    <div className="online-racetrack-stage">
      {this.renderBettingViewSwitch('online-betting-view-switch--racetrack-corner')}

      <div className="online-racetrack-layout">
        {this.renderChipSelector('online-chip-row online-racetrack-chip-rail')}
        {this.renderRacetrackBoard()}
      </div>
    </div>
  );

  renderCrossBetTargets = (targets = ONLINE_CROSS_BET_TARGETS, className = '') => (
    <div className={`online-cross-bet-layer ${className}`.trim()} role="group" aria-label="Inside combination bets">
      {targets.map(({ type, axis, numbers, betKey, left, top }) => {
        const amount = this.state.betsMap[betKey];
        const label = `${CROSS_BET_LABELS[type]} bet on ${numbers.join(', ')}`;

        return (
          <button
            type="button"
            className={`online-cross-bet-target online-cross-bet-target--${type} ${axis ? `online-cross-bet-target--${axis}` : ''} ${amount ? 'has-bet' : ''} ${this.state.isBetEraseMode && amount ? 'online-bet-target--erase-ready' : ''}`}
            key={betKey}
            style={{ left: `${left}%`, top: `${top}%` }}
            data-bet-key={betKey}
            data-bet-type={type}
            onClick={() => this.placeBet(betKey)}
            onMouseEnter={() => this.setState({ hoveredCrossBetKey: betKey })}
            onMouseLeave={() => this.setState({ hoveredCrossBetKey: '' })}
            onFocus={() => this.setState({ hoveredCrossBetKey: betKey })}
            onBlur={() => this.setState({ hoveredCrossBetKey: '' })}
            aria-label={label}
            aria-pressed={Boolean(amount)}
            title={label}
          >
            <span className="online-cross-bet-marker" aria-hidden="true"></span>
            {amount ? <span className="online-bet-chip online-bet-chip--cross">{amount}</span> : null}
          </button>
        );
      })}
    </div>
  );

  renderWheel3DOverlays = () => (
    <>
      <span className="online-wheel-3d-side" aria-hidden="true"></span>
      <span className="online-wheel-3d-face" aria-hidden="true"></span>
      <span className="online-wheel-3d-glass" aria-hidden="true"></span>
      <span className="online-wheel-3d-rim" aria-hidden="true"></span>
    </>
  );

  renderExpandedWheelPreview = () => (
    <div className="online-expanded-wheel-window" aria-hidden="true">
      <div className="roulette-wheel online-expanded-wheel-preview">
        <div className="layer-2 wheel" style={{ transform: 'rotate(0deg)' }}></div>
        <div className="layer-4 wheel" style={{ transform: 'rotate(0deg)' }}></div>
        <div className="ball-container" style={{ transform: 'rotate(0deg)' }}>
          <div
            className="ball"
            style={{
              transform: 'translateY(-163px)',
              opacity: 0,
            }}
          ></div>
        </div>
        {this.renderWheel3DOverlays()}
      </div>
    </div>
  );

  renderNumberBetTable = () => {
    return (
      <div className="online-number-table">
        <div className="online-zero-cell">
          {this.renderNumberButton(0)}
        </div>
        <div className="online-number-grid">
          {numberRows.map((row, rowIndex) => (
            <div className="online-number-row" key={rowIndex}>
              {row.map(this.renderNumberButton)}
            </div>
          ))}
        </div>
      </div>
    );
  };

  renderHorizontalNumberBetTable = () => (
    <div className="online-horizontal-number-table">
      <div className="online-horizontal-zero-cell">
        {this.renderNumberButton(0)}
      </div>
      <div className="online-horizontal-number-grid">
        {horizontalNumberColumns.map((column, columnIndex) => (
          <div className="online-horizontal-number-column" key={`horizontal-column-${columnIndex}`}>
            {column.map(this.renderNumberButton)}
          </div>
        ))}
        {this.renderCrossBetTargets(
          ONLINE_HORIZONTAL_CROSS_BET_TARGETS,
          'online-cross-bet-layer--horizontal'
        )}
      </div>
      <div className="online-horizontal-column-rail">
        {[...columnBets].reverse().map(this.renderOutsideButton)}
      </div>
    </div>
  );

  renderHorizontalBettingTable = () => {
    const horizontalOutsideBets = [
      { key: 'LOW', label: '1 - 18' },
      { key: 'EVEN', label: 'Even' },
      { key: 'RED', label: 'Red' },
      { key: 'BLACK', label: 'Black' },
      { key: 'ODD', label: 'Odd' },
      { key: 'HIGH', label: '19 - 36' },
    ];
    const horizontalSpecialBets = [
      { key: 'VOISINS', label: 'Voisins' },
      { key: 'ORPHELINS', label: 'Orphelins' },
      { key: 'TIERS', label: 'Tiers' },
      { key: 'ZEROSPIEL', label: 'Zero' },
      { key: 'SNAKE', label: 'Snake' },
      { key: 'REDSPLIT', label: 'Red Split' },
      { key: 'BLACKSPLIT', label: 'Blk Split' },
    ];

    return (
      <div className="online-horizontal-classic-stage">
        <div className="online-horizontal-betting-controls">
          {this.renderBettingViewSwitch('online-betting-view-switch--horizontal')}
          {this.renderChipSelector('online-chip-row online-horizontal-classic-chips')}
        </div>
        <div className="online-horizontal-classic-board">
          {this.renderHorizontalNumberBetTable()}
          <div className="online-horizontal-dozen-row">
            {dozenBets.map(this.renderOutsideButton)}
          </div>
          <div className="online-horizontal-outside-row">
            {horizontalOutsideBets.map(this.renderOutsideButton)}
          </div>
          <div className="online-horizontal-special-row">
            {horizontalSpecialBets.map(this.renderOutsideButton)}
          </div>
        </div>
      </div>
    );
  };

  renderHorizontalRacetrackBettingTable = () => {
    return (
      <div className="online-horizontal-racetrack-stage">
        <div className="online-horizontal-betting-controls">
          {this.renderBettingViewSwitch('online-betting-view-switch--horizontal')}
          {this.renderChipSelector('online-chip-row online-horizontal-racetrack-chips')}
        </div>
        <div className="online-horizontal-racetrack-frame">
          {this.renderRacetrackBoard({
            className: 'online-racetrack-board--horizontal',
            isHorizontal: true,
          })}
        </div>
      </div>
    );
  };

  renderRotatedBettingTable = () => {
    const rotatedDozens = [
      { key: 'DOZEN1', label: '1 - 12' },
      { key: 'DOZEN2', label: '13 - 24' },
      { key: 'DOZEN3', label: '25 - 36' },
    ];
    const rotatedOutsideBets = [
      { key: 'LOW', label: '1 - 18' },
      { key: 'EVEN', label: 'Even' },
      { key: 'RED', label: 'Red' },
      { key: 'BLACK', label: 'Black' },
      { key: 'ODD', label: 'Odd' },
      { key: 'HIGH', label: '19 - 36' },
    ];
    const rotatedSpecialBets = [
      { key: 'VOISINS', label: 'Voisins' },
      { key: 'ORPHELINS', label: 'Orphelins' },
      { key: 'TIERS', label: 'Tiers' },
      { key: 'ZEROSPIEL', label: 'Zero' },
      { key: 'SNAKE', label: 'Snake' },
      { key: 'REDSPLIT', label: 'Red Split' },
      { key: 'BLACKSPLIT', label: 'Blk Split' },
    ];

    return (
      <div className="online-expanded-table-stage">
        {this.renderExpandedWheelPreview()}

        <div className="online-rotated-board">
          <div className="online-rotated-special-rail">
            {rotatedSpecialBets.map(this.renderOutsideButton)}
          </div>

          <div className="online-rotated-outside-rail">
            {rotatedOutsideBets.map(this.renderOutsideButton)}
          </div>

          <div className="online-rotated-dozen-rail">
            {rotatedDozens.map(this.renderOutsideButton)}
          </div>

          <div className="online-rotated-number-area">
            <div className="online-rotated-zero">
              {this.renderNumberButton(0)}
            </div>
            <div className="online-rotated-number-grid">
              {rotatedNumberRows.map((row, rowIndex) => (
                <div className="online-rotated-number-row" key={`rotated-row-${rowIndex}`}>
                  {row.map(this.renderNumberButton)}
                </div>
              ))}
              {this.renderCrossBetTargets()}
            </div>
            <div className="online-rotated-column-row">
              {columnBets.map(this.renderOutsideButton)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderVerticalBettingTable = () => {
    const verticalDozens = [
      { key: 'DOZEN1', label: '1 - 12' },
      { key: 'DOZEN2', label: '13 - 24' },
      { key: 'DOZEN3', label: '25 - 36' },
    ];
    const verticalOutsideBets = [
      { key: 'LOW', label: '1 - 18' },
      { key: 'EVEN', label: 'Even' },
      { key: 'RED', label: 'Red' },
      { key: 'BLACK', label: 'Black' },
      { key: 'ODD', label: 'Odd' },
      { key: 'HIGH', label: '19 - 36' },
    ];
    const verticalSpecialBets = [
      { key: 'VOISINS', label: 'Voisins' },
      { key: 'ORPHELINS', label: 'Orphelins' },
      { key: 'TIERS', label: 'Tiers' },
      { key: 'ZEROSPIEL', label: 'Zero' },
      { key: 'SNAKE', label: 'Snake' },
      { key: 'REDSPLIT', label: 'Red Split' },
      { key: 'BLACKSPLIT', label: 'Blk Split' },
    ];

    return (
      <div className="online-expanded-table-stage online-expanded-table-stage--vertical-only">
        <div className="online-rotated-board online-rotated-board--vertical">
          <div className="online-classic-view-switch-slot">
            {this.renderBettingViewSwitch('online-betting-view-switch--classic-inline')}
          </div>

          <div className="online-rotated-special-rail">
            {verticalSpecialBets.map(this.renderOutsideButton)}
          </div>

          <div className="online-rotated-outside-rail">
            {verticalOutsideBets.map(this.renderOutsideButton)}
          </div>

          <div className="online-rotated-dozen-rail">
            {verticalDozens.map(this.renderOutsideButton)}
          </div>

          <div className="online-rotated-number-area">
            <div className="online-rotated-zero">
              {this.renderNumberButton(0)}
            </div>
            <div className="online-rotated-number-grid">
              {rotatedNumberRows.map((row, rowIndex) => (
                <div className="online-rotated-number-row" key={`vertical-row-${rowIndex}`}>
                  {row.map(this.renderNumberButton)}
                </div>
              ))}
              {this.renderCrossBetTargets()}
            </div>
            <div className="online-rotated-column-row">
              {columnBets.map(this.renderOutsideButton)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderLiveWheel = ({ showExpandButton = true, className = '' } = {}) => (
    <div className={`online-wheel-wrap ${className}`.trim()}>
      {/* {this.renderWheelJackpotLabels()} */}
      <div className="roulette-wheel">
        <div className="layer-2 wheel" style={{ transform: 'rotate(0deg)' }}></div>
        <div className="layer-4 wheel" style={{ transform: 'rotate(0deg)' }}></div>
        <div className="ball-container" style={{ transform: 'rotate(0deg)' }}>
          <div
            className="ball"
            style={{
              transform: 'translateY(-163px)',
              opacity: 0,
            }}
          ></div>
        </div>
        {this.renderWheel3DOverlays()}
        {this.renderWinCelebration()}
      </div>
      {showExpandButton && (
        <button
          type="button"
          className="online-expand-bets-button"
          onClick={this.openBettingTable}
          aria-label="Expand betting table"
          aria-expanded={this.state.isBettingTableExpanded}
        >
          <span>↑</span>
          <b>Bets</b>
        </button>
      )}
    </div>
  );

  renderExpandedTopSection = (recentSpins) => {
    const percentage = getOnlineProgressPercentage(this.state.progressPerc);

    return (
      <div className="online-expanded-status-board" aria-label="Game status">
        <div className="online-expanded-status-top">
          <OnlineGameMenu />
          {this.renderBalancePanel()}
        </div>
        <div className="online-progress online-expanded-progress">
          <div className="online-progress__bar" style={{ width: `${percentage}%` }}></div>
        </div>
        {this.renderSpinHistoryPanel(recentSpins)}
        {this.renderLuckyNumbersPanel()}
        {this.renderHotColdPanel()}
      </div>
    );
  };

  renderChipSelector = (className = 'online-chip-row') => (
    <div className={className} aria-label="Chip value">
      {ONLINE_CHIP_VALUES.map(value => (
        <button
          type="button"
          className={`online-chip online-chip--${value} ${!this.state.isBetEraseMode && this.state.betDenomination === value ? 'is-active' : ''}`}
          key={value}
          onClick={() => this.selectBetDenomination(value)}
        >
          {formatOnlineChipLabel(value)}
        </button>
      ))}
      <button
        type="button"
        className={`online-chip online-chip--erase ${this.state.isBetEraseMode ? 'is-active' : ''}`}
        onClick={this.enableBetEraseMode}
        aria-label="Clear one selected bet"
      >
        X
      </button>
    </div>
  );

  renderBettingViewSwitch = (className = '') => (
    <button
      type="button"
      className={`online-betting-view-switch ${this.state.isRacetrackView ? 'is-racetrack' : ''} ${className}`.trim()}
      onClick={this.toggleBettingTableView}
      aria-label={`Change betting table view to ${this.state.isRacetrackView ? 'classic' : 'racetrack'}`}
      aria-pressed={this.state.isRacetrackView}
    >
      <span className="online-betting-view-switch__icon" aria-hidden="true">⇄</span>
      <span className="online-betting-view-switch__copy">
        <small>Change view</small>
      </span>
    </button>
  );

  renderRepeatBetButton = (className = '') => (
    <button
      type="button"
      className={`online-repeat-bet-button ${className}`.trim()}
      onClick={this.repeatLastBet}
      disabled={this.state.isSubmittingBet}
      aria-label="Repeat the last accepted bet"
    >
      <span>Repeat</span>
      <span>Bet</span>
    </button>
  );

  renderBettingPanel = ({
    isExpanded = false,
    recentSpins = [],
    showExpandToggle = false,
    isDesktopSplit = false,
    isLargeHorizontal = false,
  } = {}) => {
    const isCompact = !isExpanded && !showExpandToggle && !isDesktopSplit;

    return (
      <section className={`online-betting-panel ${isExpanded ? 'online-betting-panel--expanded' : ''} ${isDesktopSplit ? 'online-betting-panel--desktop-split' : ''} ${isLargeHorizontal ? 'online-betting-panel--large-horizontal' : ''} ${isCompact ? 'online-betting-panel--compact' : ''}`}>
        {isExpanded && this.renderExpandedTopSection(recentSpins)}

        <div className={`online-bet-toolbar ${isExpanded || showExpandToggle || isDesktopSplit ? 'online-bet-toolbar--expanded-controls' : ''}`}>
          {(isExpanded || showExpandToggle) && (
            <button
              type="button"
              className={`online-collapse-bets-button ${showExpandToggle ? 'online-collapse-bets-button--toolbar' : ''}`}
              onClick={this.closeBettingTable}
              aria-label="Collapse betting table"
            >
              <b>↓</b>
            </button>
          )}
          <div>
            <span className="online-bet-toolbar__label">Bets</span>
            <strong>{this.getSelectedBetsCount()}</strong>
          </div>
          <div>
            <span className="online-bet-toolbar__label">Wager</span>
            <strong>${this.state.betsTotal}</strong>
          </div>
          {!isCompact && this.renderRepeatBetButton('online-repeat-bet-button--toolbar')}
          <button type="button" className="online-clear-button" onClick={this.clearBets}>
            Clear
          </button>
        </div>

        {!isCompact && (
          <>
            {!this.state.isRacetrackView && !isLargeHorizontal && this.renderChipSelector()}

            {this.state.isRacetrackView ? (
              isLargeHorizontal
                ? this.renderHorizontalRacetrackBettingTable()
                : this.renderRacetrackBettingTable()
            ) : isLargeHorizontal ? (
              this.renderHorizontalBettingTable()
            ) : isExpanded ? (
              this.renderRotatedBettingTable()
            ) : showExpandToggle || isDesktopSplit ? (
              this.renderVerticalBettingTable()
            ) : (
              <>
                {this.renderNumberBetTable()}

                <div className="online-dozen-grid">
                  {dozenBets.map(this.renderOutsideButton)}
                </div>

                <div className="online-column-grid">
                  {columnBets.map(this.renderOutsideButton)}
                </div>

                <div className="online-outside-grid">
                  {outsideBets.map(this.renderOutsideButton)}
                </div>

                <div className="online-outside-grid">
                  {finalOutsideBets.map(this.renderOutsideButton)}
                </div>

                {specialBetRows.map((row, rowIndex) => (
                  <div
                    className={`online-special-grid online-special-grid--${row.length}`}
                    key={`special-row-${rowIndex}`}
                  >
                    {row.map(this.renderOutsideButton)}
                  </div>
                ))}
              </>
            )}
          </>
        )}

        {this.state.betMessage && <div className="online-bet-message">{this.state.betMessage}</div>}
      </section>
    );
  };

  renderHistoryNumber = (number, className) => (
    <b className={`${className} ${className}--${this.getBetColor(number)}`}>
      {number}
    </b>
  );

  renderSpinHistoryPanel = (recentSpins) => {
    const spins = recentSpins.slice(0, 10);
    const currentSpinId = this.state.currentSpinId || spins[0]?.spinId || '-';

    return (
      <section className="online-scroll-strip online-scroll-strip--spin" aria-label="Spin number history">
        <div className="online-scroll-feature online-scroll-feature--spin">
          <span>Spin</span>
          <small>Number</small>
          <strong>{currentSpinId}</strong>
        </div>
        <div className="online-scroll-strip__track">
          {spins.map((item, index) => (
            <div className="online-scroll-card" key={`${item.spinId}-${index}`}>
              {/* <span>{item.spinId}</span> */}
              {this.renderHistoryNumber(item.number, 'online-scroll-card__number')}
            </div>
          ))}
        </div>
      </section>
    );
  };

  renderLargeScreenLuckyHistory = () => {
    const luckyNumbers = [...this.state.luckyArrL, ...this.state.luckyArrR].slice(0, 10);
    const historyColumns = [luckyNumbers.slice(0, 5), luckyNumbers.slice(5, 10)];
    const currentLuckyNumber = this.state.luckyNumberText || '-';

    return (
      <section className="online-large-spin online-large-spin--lucky" aria-label="Lucky number history">
        <div className="online-large-spin__marquee">
          <div className="online-large-spin__label">
            <span>Lucky</span>
            <small>Number</small>
          </div>
          <strong>{currentLuckyNumber}</strong>
        </div>
        <div className="online-large-spin__history">
          {historyColumns.map((column, columnIndex) => (
            <div className="online-large-spin__column" key={`large-lucky-column-${columnIndex}`}>
              {column.map((item, index) => (
                <div className="online-large-spin__row online-large-lucky__row" key={`${item.spinId}-${columnIndex}-${index}`}>
                  <span>{item.spinId}</span>
                  <div className="online-large-lucky__result">
                    {this.renderHistoryNumber(item.number, 'online-large-spin__number')}
                    <em>{item.jackpotType}</em>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>
    );
  };

  renderLargeScreenJackpot = () => (
    <section className="online-large-jackpot" aria-label="Mega and Mini jackpot amounts">
      <JackpotSVG animOn={this.state.animJackpotOn} restartOnPlay />
      <MiniJackpotAmount
        formattedMegaJackpot={this.formatCurrency(this.state.megaJackpot)}
        formattedMiniJackpot={this.formatCurrency(this.state.miniJackpot)}
      />
      <div className="wheel-jackpot-current1">
        <div className="wheel-jackpot-current-text">MINI JACKPOT</div>
      </div>
    </section>
  );

  renderLargeScreenRail = () => (
    <aside className="online-large-screen-rail" aria-label="Game statistics and jackpots">
      {this.renderLargeScreenLuckyHistory()}
      {this.renderLargeScreenJackpot()}
    </aside>
  );

  renderJackpotPanel = () => (
    <section className="online-jackpot-row" aria-label="Jackpot amounts">
      <div className="online-jackpot-tile online-jackpot-tile--mega">
        <span>Mega</span>
        <strong>${this.formatCurrency(this.state.megaJackpot)}</strong>
      </div>
      <div className="online-jackpot-tile online-jackpot-tile--mini">
        <span>Mini</span>
        <strong>${this.formatCurrency(this.state.miniJackpot)}</strong>
      </div>
    </section>
  );

  renderBalancePanel = () => (
    <section className="online-balance-panel" aria-label="Player wallet balance">
      <span>Balance</span>
      <strong>${this.formatCurrency(this.getDisplayedWalletBalance())}</strong>
    </section>
  );

  renderWinCelebration = () => {
    const celebration = this.state.winCelebration;

    if (!celebration) {
      return null;
    }

    const formattedAmount = this.formatCurrency(celebration.amount);

    return (
      <div
        className="online-win-celebration"
        key={celebration.id}
        role="status"
        aria-live="assertive"
        aria-atomic="true"
        aria-label={`You have won $${formattedAmount}`}
      >
        <div className="online-win-celebration__burst" aria-hidden="true">
          {ONLINE_WIN_COINS.map((coin, index) => (
            <span
              className="online-win-coin"
              key={`${celebration.id}-coin-${index}`}
              style={{
                '--coin-left': `${coin.left}%`,
                '--coin-delay': `${coin.delay}ms`,
                '--coin-duration': `${coin.duration}ms`,
                '--coin-drift': `${coin.drift}px`,
                '--coin-spin': `${coin.spin}deg`,
                '--coin-tilt': `${coin.tilt}deg`,
                '--coin-scale': coin.scale,
              }}
            >
              $
            </span>
          ))}
        </div>
        <div className="online-win-celebration__copy">
          <span>You have</span>
          <strong>Won</strong>
          <em>+${formattedAmount}</em>
        </div>
      </div>
    );
  };

  renderWheelJackpotLabels = () => (
    <div className="online-wheel-jackpot-arcs" aria-label="Jackpot amounts">
      <div className="online-wheel-jackpot-arc online-wheel-jackpot-arc--mega">
        <div className="online-wheel-jackpot-arc-content">
          <strong>${this.formatCurrency(this.state.megaJackpot)}</strong>
          <span>Mega</span>
        </div>
      </div>
      <div className="online-wheel-jackpot-arc online-wheel-jackpot-arc--mini">
        <div className="online-wheel-jackpot-arc-content">
          <strong>${this.formatCurrency(this.state.miniJackpot)}</strong>
          <span>Mini</span>
        </div>
      </div>
    </div>
  );

  renderHotColdPanel = () => {
    const hotNumbers = [this.state.hot1, this.state.hot2, this.state.hot3, this.state.hot4, this.state.hot5];
    const coldNumbers = [this.state.cold1, this.state.cold2, this.state.cold3, this.state.cold4, this.state.cold5];

    return (
      <section className="online-hot-cold-panel" aria-label="Hot and cold numbers">
        <div className="online-temperature-strip online-temperature-strip--hot">
          <span>Hot Numbers</span>
          <div className="online-temperature-strip__numbers">
            {hotNumbers.map((number, index) => (
              <b className={`online-temperature-number online-temperature-number--${this.getBetColor(number)}`} key={`hot-${index}`}>
                {number}
              </b>
            ))}
          </div>
        </div>
        <div className="online-temperature-strip online-temperature-strip--cold">
          <span>Cold Numbers</span>
          <div className="online-temperature-strip__numbers">
            {coldNumbers.map((number, index) => (
              <b className={`online-temperature-number online-temperature-number--${this.getBetColor(number)}`} key={`cold-${index}`}>
                {number}
              </b>
            ))}
          </div>
        </div>
      </section>
    );
  };

  renderLuckyNumbersPanel = () => {
    const luckyNumbers = [...this.state.luckyArrL, ...this.state.luckyArrR].slice(0, 10);
    const currentLuckyNumber = this.state.luckyNumberText || '-';

    return (
      <section className="online-scroll-strip online-scroll-strip--lucky" aria-label="Lucky number history">
        <div className="online-scroll-feature online-scroll-feature--lucky">
          <span>Lucky</span>
          <small>Number</small>
          <strong>{currentLuckyNumber}</strong>
        </div>
        <div className="online-scroll-strip__track">
          {luckyNumbers.map((item, index) => (
            <div className="online-scroll-card online-scroll-card--lucky" key={`${item.spinId}-${index}`}>
              {/* <span>{item.spinId}</span> */}
              {this.renderHistoryNumber(item.number, 'online-scroll-card__number')}
              <em>{item.jackpotType}</em>
            </div>
          ))}
        </div>
      </section>
    );
  };

  renderAuthPanel = ({ title, message, isError = false, onRetry = null }) => (
    <div className="online-wheel-page online-wheel-page--loading wheelPage-singleZero">
      <div className={`online-loading-panel online-auth-panel ${isError ? 'online-auth-panel--error' : ''}`}>
        <div className="online-loading-title">{title}</div>
        <div className="online-auth-message">{message}</div>
        {onRetry && (
          <button type="button" className="online-auth-retry" onClick={onRetry}>
            Retry
          </button>
        )}
      </div>
    </div>
  );

  render() {
    const percentage = getOnlineProgressPercentage(this.state.progressPerc);
    const recentSpins = [...this.state.betsLogL, ...this.state.betsLogR];
    const isDesktopSplitLayout = this.state.isDesktopSplitLayout;
    const isLargeDesktopLayout = this.state.isLargeDesktopLayout;

    if (this.state.playerAuthStatus === 'authenticating') {
      return this.renderAuthPanel({
        title: 'Authenticating player',
        message: 'Checking launch token and preparing your session...',
      });
    }

    if (this.state.playerAuthStatus === 'failed') {
      return this.renderAuthPanel({
        title: this.state.playerAuthCanRetry ? 'Connection interrupted' : 'Access denied',
        message: this.state.playerAuthError || 'Unable to authenticate player session',
        isError: true,
        onRetry: this.state.playerAuthCanRetry ? () => window.location.reload() : null,
      });
    }

    if (!this.state.isLoaded) {
      const loadingTitle = this.state.isSpinEntryLocked ? 'Current game in session' : 'Loading roulette';

      return (
        <div className="online-wheel-page online-wheel-page--loading wheelPage-singleZero">
          <div className="online-loading-panel">
            {this.state.isSpinEntryLocked && <div className="online-loading-timer">{this.state.bgTimer}</div>}
            <div className="online-loading-title">{loadingTitle}</div>
          </div>
        </div>
      );
    }

    return (
      <div className="online-wheel-page wheelPage-singleZero">
        {this.state.betNotification && (
          <div className="online-bet-toast" role="status" aria-live="polite">
            {this.state.betNotification}
          </div>
        )}
        <section className="online-wheel-stage">
          <header className="online-wheel-header">
            <OnlineGameMenu />
            <div className="online-wheel-pill online-wheel-pill--timer">
              <strong>{this.state.timer}</strong>
              <span>Sec</span>
            </div>
            {this.renderBalancePanel()}
            <button
              type="button"
              className="online-sound-button"
              onClick={this.toggleMute}
              aria-label={this.isMuted ? 'Unmute game audio and music' : 'Mute game audio and music'}
            >
              {this.isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
            </button>
          </header>

          <div className="online-progress">
            <div className="online-progress__bar" style={{ width: `${percentage}%` }}></div>
          </div>

          {isDesktopSplitLayout ? (
            <>
              <div className="online-desktop-feed online-desktop-feed--spin">
                {this.renderSpinHistoryPanel(recentSpins)}
              </div>
              <div className="online-desktop-feed online-desktop-feed--lucky">
                {this.renderLuckyNumbersPanel()}
              </div>
              <div className="online-desktop-feed online-desktop-feed--temperatures">
                {this.renderHotColdPanel()}
              </div>
              <div className="online-desktop-game-layout">
                {!isLargeDesktopLayout && this.renderLargeScreenRail()}
                <div className="online-desktop-wheel-column">
                  <div className="online-large-wheel-temperatures">
                    {this.renderHotColdPanel()}
                  </div>
                  <section className="online-desktop-wheel-panel" aria-label="Live roulette wheel">
                    {this.renderLiveWheel({ showExpandButton: false, className: 'online-wheel-wrap--desktop' })}
                  </section>
                </div>
                <aside className="online-desktop-table-panel" aria-label="Betting table">
                  {this.renderBettingPanel({
                    isDesktopSplit: true,
                    isLargeHorizontal: isLargeDesktopLayout,
                  })}
                </aside>
              </div>
            </>
          ) : (
            <>
              {!this.state.isBettingTableExpanded && this.renderSpinHistoryPanel(recentSpins)}
              {this.state.isBettingTableExpanded && (
                <div className={`online-slide-up-betting-panel ${this.state.isBettingTableClosing ? 'is-closing' : 'is-opening'}`} aria-label="Expanded betting table">
                  {this.renderBettingPanel({ showExpandToggle: true })}
                </div>
              )}
              {!this.state.isBettingTableExpanded && this.renderLuckyNumbersPanel()}
              {!this.state.isBettingTableExpanded && this.renderHotColdPanel()}

              {!this.state.isBettingTableExpanded && this.renderLiveWheel()}
            </>
          )}

          {/*
            Previous rotated expanded mode. Keep this block available for quick restore.
            {this.state.isBettingTableExpanded && (
              <div className="online-betting-expanded-overlay" role="dialog" aria-label="Expanded betting table">
                {this.renderBettingPanel({ isExpanded: true, recentSpins })}
              </div>
            )}
          */}
        </section>

        {!isDesktopSplitLayout && !this.state.isBettingTableExpanded && this.renderBettingPanel()}

        <audio ref={this.ballAudioRef} />
        <audio
          ref={this.winAudioRef}
          src={winCelebrationSound}
          muted={this.isMuted}
          preload="auto"
        />
        <audio
          ref={this.congratsWinAudioRef}
          src={congratsWinCelebrationSound}
          muted={this.isMuted}
          preload="auto"
        />
      </div>
    );
  }
}

export default OnlineWheelPageSZJP;
